import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from 'app/shared/utils.service';
import {
  LabelType,
  CreateUserInput,
  EntityTypeEnum,
  FileTypeEnum,
  GetDataStateQuery,
  GetEntityQuery,
  GetQuestionnaireCompletionQuery,
  GetRoleQuery,
  GetUserQuery,
  ModelEntityFilterInput,
  ModelSortDirection,
  RoleEnum,
} from 'app/API.service';
import { EntityService, GetEntityQueryExtended } from 'app/shared/entity.service';
import { NGXLogger } from 'ngx-logger';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AddUserSettingsModalComponent } from '../shared/add-user-settings-modal/add-user-settings-modal.component';
import { QuestionnaireProgressEnum } from '../shared/enums/questionnaire-progress.enum';
import { AuthService } from '../auth/auth.service';
import { TableHeader } from '../../models/table-header.model';
import { UsersSettingsService } from './users-settings.service';
import { DeleteUserModalComponent } from '../shared/user-actions/delete-user-modal/delete-user-modal.component';
import pluralize from 'pluralize';
import { DeleteModalComponent } from 'app/shared/delete-modal/delete-modal.component';
import { forkJoin, from, Observable, Subscription } from 'rxjs';
import { GetRoleQueryExtended, UserService } from 'app/shared/user.service';
import { AppLevelRoleEnum, AppLevelRoleEnumBnB } from 'app/shared/enums/appLevelRoles.enum';
import { UsersSettingConstant, UsersSettingScreens } from './users-settings.constant';
import { ThirdPartyService } from 'app/third-party/third-party.service';
import { CommonEnum } from 'app/shared/enums/common.enum';
import { ClientLambdaService } from 'app/shared/client-lambda.service';
import { KMS_STATUS, UPPERDECK_FACELIFT, EXTERNAL_SCANS_TYPE } from 'app/shared/enums/shared.enum';
import { DomainFrameworkService } from 'app/shared/domain-framework.service';
import { OnUpdateEntityByRootId } from '../../graphql/custom-subscriptions/subscription';
import { generateClient } from 'aws-amplify/api';
import { CUSTOMAPIService } from 'app/custom-api.service';
import { ModalTemplateComponent } from 'app/shared/modal-template/modal-template.component';
import { FileService } from 'app/shared/file.service';
import { NewFrameworkRequestModalComponent } from './new-framework-request-modal/new-framework-request-modal.component';
import { DomainFrameworksListingsComponent } from 'app/shared/domain-frameworks-listings/domain-frameworks-listings.component';
import { DefaultSettingsNewModalComponent } from 'app/third-party/default-settings-new-modal/default-settings-new-modal.component';
import { SMART_USER } from 'app/constants';
import { COLORS } from 'app/shared/enums/colors.enum';
import { DeleteModalTypeEnum } from 'app/shared/enums/deleteModal.enum';
import { v4 as uuid } from 'uuid';
import { BulkDynamicLabelUploadComponent } from './bulk-dynamic-label-upload/bulk-dynamic-label-upload.component';
import { CATEGORY_GROUPS, DynamicLabelManagerSections } from './users-setting.constant';
import { RiskDynamicField } from 'app/risk-register/risk-register.constant';
import { RiskDynamicFieldDeleteMode, RiskDynamicFieldService } from 'app/shared/risk-dynamic-field.service';
import { DEFAULT_SCORE_BASE } from 'app/shared/constant/scoreBase.constant';
import { ScoreService } from 'app/shared/score.service';
import { AuthSessionCacheService } from 'app/shared/auth-session-cache.service';
import { RootEntityContextService } from 'app/shared/root-entity-context.service';
import { FULL_PAGE_LOADER } from 'app/shared/full-page-loader/full-page-loader.constant';
import {
  COLD_LOAD_MODULE_KEYS,
  COLD_LOAD_SCREEN_KEYS,
  NavigationContextService,
} from 'app/shared/services/navigation-context.service';

interface UserItem {
  user: GetUserQuery;
  access: string;
}

interface AIData {
  credits?: number | null;
  date?: number | null;
  isActive?: boolean | null;
  usedCredits?: number | null;
  userName?: string | null;
}

@Component({
  selector: 'cygov-users-settings',
  templateUrl: './users-settings.component.html',
  styleUrls: ['./users-settings.component.scss'],
  standalone: false,
})
export class UsersSettingsComponent implements OnInit, OnDestroy, AfterViewInit {
  // template references
  @ViewChild('entityKMSUserPermissionTemp') entityKMSUserPermissionTemp: TemplateRef<any>;
  @ViewChild('firstPartyTemp') firstPartyTemp: TemplateRef<any>;
  @ViewChild('thirdPartyTemp') thirdPartyTemp: TemplateRef<any>;
  upperTabsContentOptions: any[] = [];

  @ViewChild('usersTemp') usersTemp: TemplateRef<any>;
  @ViewChild('rolePermissionTemp') rolePermissionTemp: TemplateRef<any>;
  @ViewChild(DomainFrameworksListingsComponent) domainFrameworksListingsComponent: DomainFrameworksListingsComponent;
  lowerTabsContentOptions: any[] = [];

  tabIdentifer: Record<any, any> = {
    upperTab: 1,
    lowerTab: 1,
  };

  isCardView = true;
  loading = true;
  innerLoading = false;
  fullPageLoading: boolean = false;
  private coldLoadKey: string;
  private fullPageLoaderTimer: ReturnType<typeof setTimeout>;
  entityId: string;
  entityList: any = [];
  vendorsList: any = [];
  entityTypeEnum = EntityTypeEnum;
  entities: Map<string, GetEntityQuery> = new Map();
  users: any = {};
  currentUser: GetUserQuery = null;
  selectedUsers: (GetQuestionnaireCompletionQuery & { assignments?: Array<any> } & { entities?: Array<any> })[] = [];
  progressObject: any = {};
  subscriptions: Subscription[] = [];
  allRoles: GetRoleQuery[] = [];
  customRoles: GetRoleQuery[] = [];
  defaultRoles: GetRoleQuery[] = [];
  selectedRole: GetRoleQuery;
  permissions: string = '';
  currentUserRole: GetRoleQueryExtended;
  showColumnTooltip: boolean = false;

  sortOptions = { name: 'na', artifacts: 'na', invitationDate: 'na', lastLogin: 'na', email: 'na' };
  previousSort = '';

  ENTITY_LEADER_ROLE = 'Entity Leader';
  SUBENTITY_LEADER_ROLE = 'Sub Entity Leader';

  status: string = 'all';
  role: string = 'all';
  statusFilter: any = { id: 'all', name: 'all' };
  roleFilter: any = { id: 'all', name: 'all' };
  statusFilterOptions = [
    { id: 'all', name: 'all' },
    ...Object.keys(QuestionnaireProgressEnum).map(key => {
      this.progressObject[key] = QuestionnaireProgressEnum[key];
      return {
        id: QuestionnaireProgressEnum[key],
        name: QuestionnaireProgressEnum[key],
      };
    }),
  ];
  roleFilterOptions = null;
  filteredUserList = [];
  // users with a save or delete in flight, so those rows render as skeletons until it settles
  busyUserIds = new Set<string>();
  // a user being created holds a skeleton row at the top of the list, where mapUserProgress
  // prepends it once the request returns
  isCreatingUser = false;
  // a custom role being created holds a new tile in the role list while the request runs, and a
  // role being updated turns its own tile into a placeholder; the panel stays mounted but hidden
  // either way, so its in-flight save is not destroyed with the view
  pendingRoleName: string = null;
  pendingRoleId: string = null;
  // `searchText` is the APPLIED term that all filtering reads; `searchInputText` is what is
  // currently typed in the box but not yet submitted
  searchText = '';
  searchInputText = '';
  // search matches Policy Management: Enter runs it and the shared in-process panel holds the
  // list for the brief apply window
  isSearching = false;
  private searchDebounceTimer: ReturnType<typeof setTimeout> = null;
  private filterApplyTimer: ReturnType<typeof setTimeout> = null;
  private readonly SEARCH_APPLY_MS = 500;
  isEditMode: boolean = false;
  /** Snapshot of original privileges for users staged via Regulatory Watch Admin, keyed by user id. */
  private _pendingRegulatoryWatchSnapshot: Map<string, string[]> = new Map();
  showRolePermission: boolean = false;
  isDefaultRole: boolean = false;

  isInviteSent: boolean = false;
  ngbModalDeleteUserOptions: NgbModalOptions = {
    size: 'sm',
    windowClass: 'delete-user-settings-modal delete-collection-framework-modal',
    backdropClass: 'delete-user-settings-custom-role-backdrop-modal delete-collection-framework-backdrop-modal',
    backdrop: 'static',
  };

  ngbModalDeleteDynamicLabelOptions: NgbModalOptions = {
    size: 'sm',
    windowClass: 'delete-dynamic-label-modal delete-collection-framework-modal',
    backdropClass: 'delete-user-settings-custom-role-backdrop-modal delete-collection-framework-backdrop-modal',
    backdrop: 'static',
  };
  ngbModalRiskConfirmOptions: NgbModalOptions = {
    size: 'sm',
    windowClass: 'delete-user-settings-modal delete-collection-framework-modal risk-ai-confirmation-modal',
    backdropClass: 'delete-user-settings-custom-role-backdrop-modal delete-collection-framework-backdrop-modal',
    backdrop: 'static',
  };
  ngbModalOptions: NgbModalOptions = {
    size: 'sm',
    // modal-template-cont, modal-template-cont-backdrop must classes for standard design of popup
    windowClass: 'modal-template-cont user-settings-popup-modal',
    backdropClass: 'delete-user-settings-backdrop-modal',
    backdrop: 'static',
  };

  ngbModalOptionsDynamicLabelBulkUpload: NgbModalOptions = {
    size: 'sm',
    // modal-template-cont, modal-template-cont-backdrop must classes for standard design of popup
    windowClass: 'modal-template-cont dynamic-label-bulk-upload-popup-window',
    backdropClass:
      'modal-template-cont-backdrop dynamic-label-bulk-upload-popup-backdrop-modal md-modal-template-backdrop',
    backdrop: 'static',
  };
  ngbModalOptionsConfirmation: NgbModalOptions = {
    size: 'sm',
    // modal-template-cont, modal-template-cont-backdrop must classes for standard design of popup
    windowClass: 'modal-template-cont confirmation-filter-popup-window credit-package-popup-window',
    backdropClass: 'modal-template-cont-backdrop risk-popup-backdrop-modal credit-package-modal-template-backdrop',
    backdrop: 'static',
  };
  ngbModalOptionsAttackSurface: NgbModalOptions = {
    size: 'sm',
    // modal-template-cont, modal-template-cont-backdrop must classes for standard design of popup
    windowClass: 'modal-template-cont confirmation-filter-popup-window attack-surface-modal-window',
    backdropClass: 'modal-template-cont-backdrop risk-popup-backdrop-modal attack-surface-modal-template-backdrop',
    backdrop: 'static',
  };
  ngbModalOptionsExternalScanRequest: NgbModalOptions = {
    size: 'sm',
    // modal-template-cont, modal-template-cont-backdrop must classes for standard design of popup
    windowClass: 'modal-template-cont confirmation-filter-popup-window external-scan-request-modal-window',
    backdropClass: 'modal-template-cont-backdrop risk-popup-backdrop-modal external-scan-request-modal-backdrop',
    backdrop: 'static',
  };
  ngbModalOptionsExternalScanRequestScanAcknowledgement: NgbModalOptions = {
    size: 'sm',
    // modal-template-cont, modal-template-cont-backdrop must classes for standard design of popup
    windowClass:
      'modal-template-cont confirmation-filter-popup-window external-scan-request-scan-acknowledgement-modal-window',
    backdropClass:
      'modal-template-cont-backdrop risk-popup-backdrop-modal external-scan-request-scan-acknowledgement-modal-backdrop',
    backdrop: 'static',
    centered: true,
  };
  ngbModalOptionsNewFrameworkRequest: NgbModalOptions = {
    size: 'sm',
    windowClass: 'modal-template-cont  new-framework-request-modal-window',
    backdropClass: 'modal-template-cont-backdrop new-framework-request-modal-backdrop',
    backdrop: 'static',
  };

  ngbModalOptionsExternalScans: NgbModalOptions = {
    size: 'sm',
    // modal-template-cont, modal-template-cont-backdrop must classes for standard design of popup
    windowClass: 'modal-template-cont confirmation-filter-popup-window external-scan-modal-window',
    backdropClass: 'modal-template-cont-backdrop risk-popup-backdrop-modal external-scan-modal-template-backdrop',
    backdrop: 'static',
  };

  modalRef: any;
  roleSelected = false;
  tmpRole: any;
  childEntities: GetEntityQuery[] = [];
  vendorEntities: any[] = [];
  vendorHash: any[] = [];
  tmpSelectedUsers;
  entity: GetEntityQuery;
  UsersSettingConstant = UsersSettingConstant;
  UsersSettingScreens = UsersSettingScreens;
  currentTab: string = UsersSettingScreens.users;
  isUsersScreen: boolean = true;
  isBnb: boolean = UtilsService.isBnB;
  isBeecher: boolean = UtilsService.isBnBCyberSite;
  isGlobalUserSetting: boolean = false;
  entitySelectionMode: boolean = true;
  rootEntities: GetEntityQueryExtended[] = [];
  // Root entities page in as the picker grid or the entity dropdown is scrolled, rather than the
  // whole index being walked up front. Same paging helper the Management screen uses.
  readonly ROOT_ENTITY_PAGE_SIZE = 30;
  rootEntitiesNextToken: string = null;
  isLoadingMoreRootEntities = false;
  // Each section clears its own flag the moment its data lands, so one slow fetch cannot hold the
  // rest of the screen behind it. They are reset at the top of ngOnInit, which is re-entrant.
  isRootEntitiesLoading = true;
  isUsersSectionLoading = true;
  isKmsSectionLoading = true;
  isAiSectionLoading = true;
  activeTabId: number = 1;
  isCurrentUserAdmin: boolean = false;
  commonEnum = CommonEnum;
  kmsToggle: boolean = false;
  rotationInProgress: boolean = false;
  activationInProgress: boolean = false;
  isManagerialRole: boolean = false;
  entityIdInUrl: boolean = false;
  kmsEnum = KMS_STATUS;
  user: GetUserQuery;
  timers = [];
  modalReference: NgbModalRef = null;

  singleEntityLenghtCheck = false;
  isMidMarket: boolean = UtilsService.isMidMarket;
  nextOffset: number = 10;
  assessments: any = [];
  allUsers: any = [];
  assignedUsers: any = [];
  closeModalInstance;
  aiData: AIData;
  isAITabAccess: boolean;
  isAIUpdateInProgress: boolean = false;
  activeScan: boolean = false;
  domainValue: string = '';
  updatedDomainValue: string = '';
  intervalId: any;
  entityDomainValue: string = '';
  isEdit: boolean = false;
  isLogoUploaded: boolean = true;
  isAttackSurfaceTabAccess: boolean = false;
  rootEntityId: string;
  riskFrameworks: any[] = [];
  standardList: any[] = [];
  domainSetting = null;
  logoUrl: string = null;
  isNotFromRotation: boolean = false;
  isThirdPartyTabDisabled: boolean = false;
  disableScanning: boolean;
  externalFeeds = [
    {
      logo: 'NVD-white-55.png',
      status: COLORS.GREEN,
    },
    {
      logo: 'centraleyes-watch.png',
      status: COLORS.GREEN,
    },
    {
      logo: 'DHS-CISA-Logo.png',
      status: COLORS.GREEN,
    },
    {
      logo: 'ce-intel.png',
      status: COLORS.GREEN,
    },
    {
      logo: 'exploit-database.png',
      status: COLORS.GREEN,
    },
  ];
  externalServices = [
    {
      logo: 'shodan.png',
      status: COLORS.GREEN,
    },
    {
      logo: 'dark-watch.png',
      status: COLORS.GREEN,
    },
    {
      logo: 'bucket-scanner.png',
      status: COLORS.GREEN,
    },
    {
      logo: 'centraleyes-db-breach.png',
      status: COLORS.GREEN,
    },
  ];
  domains = [{ value: '', isFromDb: false }];
  bitsightUrl: string = 'https://api.bitsighttech.com';
  bitsightToken: string;
  externalScans = EXTERNAL_SCANS_TYPE;
  currentScanType = this.externalScans.CENTRALEYES;
  bitSightStatus: string = null;
  cachedDomains = [{ value: '', isFromDb: false }];
  scanInProgess: boolean = false;
  isPolicyManager: boolean = false;
  isRegulationManager: boolean = false;
  defaultCategoryGroups = CATEGORY_GROUPS;

  // Risk Register -> Dynamic Field section (First Party tab).
  // wizard's Dynamic Field step.
  riskRegisterDynamicFields: RiskDynamicField[] = [];
  isRiskDynamicFieldLoading = false;
  /** Guards SAVE / DELETE against a double submit while a write is in flight. */
  isRiskDynamicFieldSaving = false;
  /** The field the panel is editing; null with the panel open means "create". */
  selectedRiskRegisterDynamicField: RiskDynamicField = null;
  // a dynamic field whose save or delete is in flight holds its own card as a skeleton; a field
  // being created holds a new card at the end of the row, where createField's order puts it
  pendingDynamicFieldKey: string = null;
  isCreatingDynamicField = false;
  readonly dynamicFieldSkeletonCards = [1, 2, 3];
  // placeholder rows in each Dynamic Label Manager panel while a section loads
  readonly dynamicLabelSkeletonRows = [1, 2];
  // placeholder tiles in the Choose Entity picker while the root entities are fetched: enough to
  // fill the grid's visible rows, which scrolls past that
  readonly entityPickerSkeletonTiles = Array.from({ length: 12 }, (_, index) => index);
  isRiskDynamicFieldPanelOpen = false;
  riskDynamicFieldEditMode = false;
  /** Field awaiting delete confirmation; non-null shows the dialog. */
  riskDynamicFieldPendingDelete: RiskDynamicField = null;
  /** How many risks answered the field the panel is editing. */
  riskDynamicFieldUsageCount = 0;

  // Dynamic Label Manager Variables.
  dynamicLabelManagerSections = [
    { name: DynamicLabelManagerSections.GENERAL_TAGS, isSelected: true },
    { name: DynamicLabelManagerSections.RISK_REGISTER, isSelected: false },
    { name: DynamicLabelManagerSections.POLICY_MANAGEMENT, isSelected: false },
    { name: DynamicLabelManagerSections.REMEDIATION, isSelected: false },
  ];
  dynamicLabelManagerEditMode: boolean = false;

  dynamicLabelManagerMapper = {
    title: '',
    tagsTitle: '',
    categoriesTitle: '',
    tags: [],
    categories: [],
    type: null,
  };

  filteredDynamicLabelManagerItems = { ...JSON.parse(JSON.stringify(this.dynamicLabelManagerMapper)) };

  selectedDynamicLabelManagerItems: any = {
    tags: [],
    categories: [],
  };
  isPolicyCategorySelected: boolean = true;
  currentSelectedSection: string;
  isAddEnabled: boolean;
  newTagValue: string = '';
  isDynamicLabelManagerLoading: boolean = false;
  searchFormObject = {
    tagSearchText: '',
    categorySearchText: '',
  };
  bulkUploadPromise: Promise<any>[] = [];
  isPolicyManagementTabAccess: boolean = false;
  /**
   * Beecher/Midmarket only get the tabbed General/1st Party settings view (with the AI toggle)
   * when they've navigated to a specific entity's settings (`/first-party/:entityId/user-settings`).
   * The global "/clients/user-settings" view (no entityId in the route) must stay on the original
   * bnbNBeacherTemplate, unchanged.
   */
  hasEntityIdInRoute: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private entityService: EntityService,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    private logger: NGXLogger,
    private userSettingService: UsersSettingsService,
    private userService: UserService,
    private thirdPartyService: ThirdPartyService,
    private clientLambdaService: ClientLambdaService,
    private customAPI: CUSTOMAPIService,
    private riskDynamicFieldService: RiskDynamicFieldService,
    private fileService: FileService,
    private domainFrameworkService: DomainFrameworkService,
    private router: Router,
    private scoreBaseService: ScoreService,
    private authSessionCacheService: AuthSessionCacheService,
    private rootEntityContextService: RootEntityContextService,
    private navigationContext: NavigationContextService
  ) {
    this.hasEntityIdInRoute = !!UtilsService.getRouteParam(this.route.root.snapshot, 'entityId');
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  async ngOnInit(): Promise<any> {
    // this screen serves three routes (`/settings`, `/clients/user-settings` and
    // `/first-party/:entityId/user-settings`), so claim the key its own URL maps to
    this.coldLoadKey = this.router.url.includes('/user-settings')
      ? COLD_LOAD_SCREEN_KEYS.USER_SETTINGS
      : COLD_LOAD_MODULE_KEYS.SETTINGS;
    this.fullPageLoading = FULL_PAGE_LOADER.USERS_SETTINGS && this.navigationContext.claimColdLoad(this.coldLoadKey);
    this.resetSectionLoadingFlags();
    if (this.fullPageLoading) {
      this.fullPageLoaderTimer = setTimeout(() => this.stopFullPageLoader(), FULL_PAGE_LOADER.SAFETY_TIMEOUT_MS);
    }
    try {
      // handle the entitied list section for entity-leader
      this.currentUser = await this.userService.getCurrentUser();
      this.currentUserRole = this.userService.getCurrentRole();

      this.isPolicyManager = this.currentUserRole?.name === AppLevelRoleEnum.POLICY_MANAGER;
      this.isRegulationManager = this.currentUserRole?.name === AppLevelRoleEnum.REGULATION_MANAGER;
      if (
        this.currentUserRole &&
        this.currentUserRole.name.toLowerCase() === AppLevelRoleEnum.ENTITY_LEADER.toLowerCase()
      ) {
        this.entityId = this.currentUser.entityId;
        this.entity = await this.rootEntityContextService.getRootEntityById(this.entityId);
        this.entitySelectionMode = false;
      }
      // Beecher/Midmarket only go through entity-selection/domain-setting init when they're on an
      // entity-specific route (`/first-party/:entityId/user-settings`, tabbed settings view). Their
      // global `/clients/user-settings` route keeps the original bnbNBeacherTemplate init path below
      // (isGlobalUserSetting only) so it keeps loading Users the way it always has.
      if (!this.isBnb && (!(this.isBeecher || this.isMidMarket) || this.hasEntityIdInRoute)) {
        if (!this.entityId) {
          // if entityId exist in params, it means not global user setting, so dont need to select entity
          this.entitySelectionMode = !UtilsService.getRouteParam(this.route.root.snapshot, 'entityId');
        }
        this.isThirdPartyTabDisabled = this.router.url.includes('first-party');
        // Beecher/Midmarket don't use the domain-scan/frameworks settings (External Scans, Score
        // Base, Frameworks sections are hidden for them in the 1st Party tab) so skip fetching it.
        if (!this.isBeecher && !this.isMidMarket) {
          this.domainSetting = this.domainFrameworkService.getSettingFromDomain;
          if (!this.domainSetting) {
            await this.domainFrameworkService.getDomainSetting();
            this.domainSetting = this.domainFrameworkService.getSettingFromDomain;
          }
        }
        // this.riskFrameworks = settings.RISK_FRAMEWORKS;
        // this.standardList = settings.COMPLIANCE_FRAMEWORKS;
        this.isGlobalUserSetting = this.userSettingService.isGlobalUserSettings();
        if (this.entitySelectionMode && !this.entity) {
          this.rootEntities = await this.getExtendEntityList();
          this.isRootEntitiesLoading = false;
          // A third-party "activate AI" link names its entity: land on it, not the Choose Entity grid.
          // The entity may sit beyond the first page, so fall back to fetching it by id.
          const preselectedEntityId = window.history?.state?.settingsEntityId;
          let preselectedEntity = preselectedEntityId
            ? this.rootEntities.find(rootEntity => rootEntity.id === preselectedEntityId)
            : null;
          if (preselectedEntityId && !preselectedEntity) {
            preselectedEntity = await this.rootEntityContextService.getRootEntityById(preselectedEntityId);
          }
          // Only auto-select a lone entity when there is genuinely no other page behind it.
          const isOnlyRootEntity = this.rootEntities.length === 1 && !this.hasMoreRootEntities;
          if (isOnlyRootEntity || preselectedEntity) {
            // Single root entity: select it inline and CONTINUE this same init pass, instead of
            // re-running ngOnInit() via selectEntityForSettings(). That re-entry was duplicating every
            // init call (GetEntity, EntitiesByParent, roles, domain settings, users, etc.) on landing.
            this.singleEntityLenghtCheck = isOnlyRootEntity;
            this.entity = preselectedEntity || this.rootEntities[0];
            this.entityId = this.entity.id;
            this.entitySelectionMode = false;
            this.isGlobalUserSetting = false;
            this.activeScan = this.entity.domainScanned ? this.entity.domainScanned : false;
            const domainArr = this.entity.domainScanTimes ? JSON.parse(this.entity.domainScanTimes) : [];
            this.entityDomainValue = domainArr?.length ? domainArr[0].name : '';
            // fall through to load the rest of the screen in this single pass
          } else {
            // Multiple root entities: show the selection screen and stop here.
            this.singleEntityLenghtCheck = false;
            this.clearSectionLoadingFlags();
            this.loading = false;
            this.stopFullPageLoader();
            return;
          }
        } else if (!this.entitySelectionMode) {
          this.isGlobalUserSetting = false;
        }
      } else {
        this.isGlobalUserSetting = this.userSettingService.isGlobalUserSettings();
      }
      this.subscriptions.push(
        this.userSettingService.currEntRoles.subscribe(roles => {
          if (roles && !!roles.length && !this.isGlobalUserSetting) {
            this.setPrivileges(roles);
          } else if (roles && !!roles.length) {
            this.allRoles = this.userSettingService.currEntRolesList;
            this.customRoles = this.allRoles.filter(role => UtilsService.isDefined(role.entityId));
          }
        })
      );

      if (this.isGlobalUserSetting && (this.isBnb || this.isBeecher || this.isMidMarket)) {
        // Get All Root Entities (Domain) and Cache them in Users Setting Service
        const rootEntities = await this.entityService.listEntitysByEntityType(
          EntityTypeEnum.ROOT_ENTITY,
          null,
          this.assignedRootEntityFilter()
        );
        this.userSettingService.setGlobalEntities(rootEntities);
        const result = await this.userSettingService.getGlobalRoles(rootEntities);
        this.allRoles = [];
        result.map(roleList => {
          this.allRoles = this.allRoles.concat(roleList);
        });
        if (this.currentUserRole.name !== AppLevelRoleEnum.ADMIN) {
          this.allRoles = this.allRoles.filter(role => {
            return role.name !== AppLevelRoleEnum.ADMIN;
          });
        }

        // removing the vendor role.
        const vendorRoleIndex = this.allRoles.findIndex(role => role?.name === AppLevelRoleEnum.VENDOR);
        if (vendorRoleIndex > -1) {
          this.allRoles.splice(vendorRoleIndex, 1);
        }
        this.userSettingService.setRoles(this.allRoles);
        this.roleFilter = { id: 'all', name: 'all' };
      } else {
        // this part will work only when we need to access User-Settings from First Party
        this.subscriptions.push(
          this.userSettingService.currEntRoles.subscribe(roles => {
            if (roles && roles.length) {
              this.setPrivileges(roles);
            }
          })
        );
        if (!this.entityId) {
          this.entityId = UtilsService.getRouteParam(this.route.root.snapshot, 'entityId');
          if (!this.authService.isNotFromHigherRoles() && this.entityId) {
            this.entity = await this.rootEntityContextService.getRootEntityById(this.entityId);
          }
        }

        if (!this.authService.isNotFromHigherRoles()) {
          const frameworkSettings = this.entity?.frameworkSettings && JSON.parse(this.entity?.frameworkSettings);
          const dominFrameworkSettings = this.domainSetting?.settings ? JSON.parse(this.domainSetting?.settings) : {};
          this.riskFrameworks = this.checkIfNewFrameworkAdded(
            dominFrameworkSettings?.RISK_FRAMEWORKS,
            frameworkSettings?.RISK_FRAMEWORKS || dominFrameworkSettings.RISK_FRAMEWORKS
          );
          this.standardList = this.checkIfNewFrameworkAdded(
            dominFrameworkSettings?.COMPLIANCE_FRAMEWORKS,
            frameworkSettings?.COMPLIANCE_FRAMEWORKS || dominFrameworkSettings.COMPLIANCE_FRAMEWORKS
          );
        }

        await this.getChildEntities();
        this.userSettingService.setCurrEntity(this.entityId);
        const entityCustomRoles = await this.userService.getRolesByDefaultOrEntityId(this.entityId, false);
        const defaultRoles = await this.userService.getRolesByDefaultOrEntityId(UsersSettingConstant.default, true);
        await this.setPrivileges();
        this.entities = await this.getEntitiesMap();
        this.userSettingService.setRolesInCurrentEntity([...entityCustomRoles, ...defaultRoles]);
      }

      this.users = {};
      this.statusFilterOptions.forEach(element => (this.users[element.id] = []));
      await this.fetchAllUsers();
      // if BNB then we need to update the default roles with their parent role permissions.
      if (this.isBnb) {
        this.defaultRoles = await this.userService.updateDefaultRolesPermissions(this.defaultRoles);
      }
      // Filtering users before showing on frontend so that no duplicate exist
      this.filterUniqueEmailUsers();
      this.filteredUserList = [...this.users[this.status]];
      this.isUsersSectionLoading = false;
      this.getVendorUsersList();
      // get Entity Roles and set these roles in User setting Service so that all components
      // of user setting module can use it.

      if (this.userSettingService.getIsEditMode()) {
        this.userSettingService.setIsEditMode(false);
      }
      this.isManagerialRole = this.userService.isManagerialRole();
      if (this.isManagerialRole) {
        await this.setLatestEntityStatus();
        this.isAITabAccess = true;
      }
      // a non-managerial role sees neither section, so nothing is left waiting on them
      this.isAiSectionLoading = false;
      if (!this.isManagerialRole) {
        this.isKmsSectionLoading = false;
      }
      this.entityIdInUrl =
        !!UtilsService.getRouteParam(this.route.root.snapshot, 'entityId') ||
        this.currentUserRole.name.toLowerCase() === AppLevelRoleEnum.ENTITY_LEADER.toLowerCase();
      if (UtilsService.isDefined(this.entityId)) {
        const entityId = this.entityId;
        const currentSession = await this.authSessionCacheService.getSession();
        const client = generateClient();
        this.subscriptions.push(
          (
            client.graphql({
              query: OnUpdateEntityByRootId,
              variables: {
                id: entityId,
              },
              authMode: 'lambda',
              authToken: currentSession.tokens.accessToken.toString(),
            }) as unknown as Observable<any>
          ).subscribe({
            next: res => {
              const updatedEntity = res?.data?.onUpdateEntityByRootId;
              if (updatedEntity) {
                this.onEncryptionResponse(updatedEntity);
              }
            },
            error: err => {
              console.log('OnUpdateEntityByRootId subscriptions: ', err);
              // if appsync closes connection try getting the latest entity state
              if (UtilsService.isDefined(this.entityId)) {
                this.timers.push(
                  setInterval(() => {
                    void (async () => {
                      const latestEntity = await this.entityService.getEntity(this.entityId, false);
                      this.onEncryptionResponse(latestEntity);
                    })();
                  }, 10000)
                );
              }
            },
          })
        );
      }
      this.activationInProgress = this.entity?.KMS?.status === KMS_STATUS.IN_PROGRESS.toUpperCase();
      this.rotationInProgress = this.entity?.KMS?.rotations?.status === KMS_STATUS.IN_PROGRESS.toUpperCase();
      this.isKmsSectionLoading = false;
      const roleMapper = this.userService.roleIDToNameMapper;
      if (roleMapper[this.currentUser.roleId] === AppLevelRoleEnum.ADMIN.toLowerCase()) {
        this.isCurrentUserAdmin = true;
      }

      if (this.entity) {
        this.disableScanning = this.entity?.domainScanStatus === 'Inprogress';
        this.activeScan = this.entity.domainScanned ? this.entity.domainScanned : false;
        const domainArr = this.entity.domainScanTimes ? JSON.parse(this.entity.domainScanTimes) : [];

        if (domainArr?.length && this.domains[0]?.value === '') {
          this.domains = [];
        }
        domainArr.forEach(dom => {
          if (dom?.name && dom?.name !== '') {
            this.domains.push({ value: dom?.name, isFromDb: true });
          }
        });
        this.isEdit = this.activeScan ? true : false;
        this.logoUrl = (await this.entityService.setLogoUrl(this.entity)).logoUrl;

        if (this.entity?.integrations?.length) {
          const isBitSightExists = this.entity.integrations.find(int => int?.name === 'bitsight');
          if (isBitSightExists) {
            this.currentScanType = EXTERNAL_SCANS_TYPE.INTEGRATION;
            if (isBitSightExists?.isAuth) {
              this.bitSightStatus = 'green';
            } else {
              this.bitSightStatus = 'grey';
            }
          }
        }

        if (this.entity?.selectedService === EXTERNAL_SCANS_TYPE.CENTRALEYES) {
          this.currentScanType = EXTERNAL_SCANS_TYPE.CENTRALEYES;
        }
      }

      // AI settings live in the General tab, which is the default — nothing to select.
      this.buildUpperTabsContentOptions();
      this.buildLowerTabsContentOptions();
      this.clearSectionLoadingFlags();
      this.loading = false;
      this.stopFullPageLoader();
    } catch (e) {
      this.logger.error(e);
      this.toastrService.error('UsersSettingsComponent - Error: ', e);
      this.clearSectionLoadingFlags();
      this.stopFullPageLoader();
    }
    // check if policy management tab is accessible
    this.isPolicyManagementTabAccess = this.entity?.solutionStatus?.items?.find(
      item => item.key === 'policyManagement'
    )?.enabled;
    if (!this.isPolicyManagementTabAccess) {
      this.dynamicLabelManagerSections = this.dynamicLabelManagerSections.filter(
        section => section.name !== DynamicLabelManagerSections.POLICY_MANAGEMENT
      );
    }
    if (this.entityId) {
      this.populateDynamicLabelManagerSections(DynamicLabelManagerSections.GENERAL_TAGS);
      this.getRiskDynamicFields();
    }
  }

  isFromHigherRoles(): boolean {
    return !!(
      this.currentUserRole?.name?.toLowerCase() === 'admin' && this.currentUserRole?.name?.toLowerCase() === 'mssp'
    );
  }

  checkIfNewFrameworkAdded(domainFrameworks = [], entityFrameworks = []) {
    domainFrameworks.forEach(item => {
      // Check if the item from array1 is not present in array2
      const isInArray2 = entityFrameworks.some(obj => obj.name === item.name);
      // Add the object with status true to array2 if it's not already present
      if (!isInArray2 && item.status === true) {
        entityFrameworks.push({ ...item, status: false });
      }
    });

    entityFrameworks = entityFrameworks.filter(item =>
      domainFrameworks.some(obj => obj.name === item.name && obj.status === true)
    );

    return entityFrameworks;
  }

  async updateFrameworkSetting() {
    const formatedObject = {
      id: this.entity.id,
      frameworkSettings: JSON.stringify(this.domainFrameworksListingsComponent.formatFrameworkArrays()),
    };
    this.isNotFromRotation = true;
    await this.entityService.updateEntity(formatedObject);
    this.rootEntityContextService.addOrUpdateSubEntityInCache(formatedObject);

    this.toastrService.success('Framework Settings updated successfully');
  }

  checkPermissionForExternalDomainScan() {
    if (
      this.currentUserRole.name.toLowerCase() === AppLevelRoleEnum.ADMIN.toLowerCase() ||
      this.currentUserRole.name.toLowerCase() === AppLevelRoleEnum.MSSP.toLowerCase() ||
      this.currentUserRole.name.toLowerCase() === AppLevelRoleEnum.SUPER_ENTITY_LEADER.toLowerCase()
    ) {
      return true;
    }
    return false;
  }

  async imgHandler(eventFile: Event): Promise<void> {
    try {
      const value = await this.fileService.verifyUploadFile(eventFile, FileTypeEnum.LOGO);
      if (!value) {
        return;
      }
      const s3Input = await this.fileService.convertToS3Input(eventFile, this.entity.id);
      this.logoUrl = await this.fileService.getUploadedImg(eventFile);
      const updatedLogo = await this.fileService.uploadToS3(s3Input);
      await this.customAPI.UpdateEntity({
        id: this.entity.id,
        logo: updatedLogo,
      });
      this.entity.logo = updatedLogo;
      this.rootEntityContextService.addOrUpdateSubEntityInCache({ id: this.entity.id, logo: updatedLogo });
    } catch (error) {
      this.logger.error('Image Handler  Error =', error);
      this.toastrService.error(error);
      eventFile = null;
    }
  }

  /**
   * Function to filter Unique users only as there is an issue of duplicate SSO users
   */
  filterUniqueEmailUsers() {
    Object.keys(this.users).forEach(catogory => {
      this.users[catogory] = this.users[catogory].filter((userObj, index, self) => {
        return index === self.findIndex(u => u.user?.email === userObj.user?.email);
      });
    });
  }

  ngAfterViewInit(): void {
    // Initialiation Upper tabs data
    this.buildUpperTabsContentOptions();
    // Initialization Lower Tabs Data. Built here as well as after the load so the Users section
    // can render with skeletons instead of the screen sitting blank until the data arrives.
    this.buildLowerTabsContentOptions();
  }

  private buildLowerTabsContentOptions(): void {
    this.lowerTabsContentOptions = [
      { label: `${this.filteredUserList.length} Users`, content: this.usersTemp, relativePos: true },
      ...(!this.isPolicyManager && !this.isRegulationManager
        ? [{ label: 'Role Permissions', content: this.rolePermissionTemp, relativePos: true }]
        : []),
    ];
  }

  // Beecher/Midmarket have no 1st Party content, so hide that tab rather than render an empty one.
  private buildUpperTabsContentOptions(): void {
    this.upperTabsContentOptions = [{ label: this.commonEnum.GENERAL, content: this.entityKMSUserPermissionTemp }];
    if (!this.isBeecher && !this.isMidMarket) {
      this.upperTabsContentOptions.push({
        label: this.commonEnum.FIRSTPARTY,
        content: this.firstPartyTemp,
        disabled: this.isFirstPartyTabDisabled(),
      });
    }
    if (!this.isThirdPartyTabDisabled) {
      this.upperTabsContentOptions.push({
        label: this.commonEnum.THIRDPARTY,
        content: this.thirdPartyTemp,
        disabled: this.isThirdPartyTabDisabled || !this.entity?.solutionStatus?.thirdParty,
      });
    }
  }

  // The 1st Party tab's content is entity-scoped, so it needs a resolved entity.
  isFirstPartyTabDisabled(): boolean {
    return this.isFromHigherRoles() || !this.entity?.solutionStatus?.firstParty;
  }

  changeTabActiveId(data): void {
    const splitData = data.split('#');
    if (splitData[1] === '1') {
      this.isNotFromRotation = false;
    }
    this.tabIdentifer[splitData[0]] = splitData[1];

    const currentContentOptionIndex = +splitData[1] - 1;
    // Match on label, not position — the 1st Party tab is absent for some tenants.
    const selectedOption = this[`${splitData[0]}sContentOptions`]?.[currentContentOptionIndex];
    if (splitData[0] === 'upperTab' && selectedOption?.label === this.commonEnum.THIRDPARTY) {
      this.modalReference = this.modalService.open(DefaultSettingsNewModalComponent, {
        centered: true,
        size: 'lg',
        windowClass: 'default-setting-modal',
        backdropClass: 'default-setting-backdrop',
        backdrop: 'static',
        animation: false,
      });
      this.userSettingService.setModalReference(this.modalReference);
      this.modalReference.componentInstance.entityId = this.entityId;
      this.modalReference.componentInstance.isFromGeneralSettings = true;
      this.modalReference.componentInstance.closeDefaultModal.subscribe(() => {
        this.closeModal();
      });
    } else {
      this.closeModal();
    }
    // check if tab is All Users then enable relative position for container for "Add New User" btn styling
    this[`${splitData[0]}sContentOptions`][0].relativePos = UtilsService.isDefined(
      this[`${splitData[0]}sContentOptions`][currentContentOptionIndex].relativePos
    );

    this.closeModalInstance = this.modalRef;
  }

  /**
   * updated the vendor entity with its user.
   */
  getVendorUsersList(): void {
    if (this.vendorEntities && this.vendorEntities.length && this.filteredUserList) {
      this.vendorEntities.forEach(entity => {
        entity.userCounter = 0;
        this.filteredUserList.forEach(filteredUser => {
          if (filteredUser.user.entityIds && filteredUser.user.entityIds[0] === entity.id) {
            entity.userCounter += 1;
          }
        });
      });
      if (this.vendorEntities) {
        this.vendorEntities.map(vendor => (this.vendorHash[vendor.id] = vendor));
      }
    }
  }

  /**
   * gets the list of child entities including the entities as well.
   */
  async getChildEntities(): Promise<void> {
    const entities = await this.rootEntityContextService.getSubEntities();
    this.childEntities = entities.filter(entity => entity?.entityType === 'CHILD_ENTITY');
    this.vendorEntities = entities.filter(entity => entity?.entityType === 'VENDOR');
  }

  /**
   * only Admin , Mssp and Entity Leader (default role) can access the role section
   * @returns boolean value
   */
  isCurrentUserAccessRoleSection(): boolean {
    return (
      this.currentUserRole &&
      this.currentUserRole.name &&
      (this.currentUserRole.name.toLowerCase() === AppLevelRoleEnum.ADMIN.toLowerCase() ||
        this.currentUserRole.name.toLowerCase() === AppLevelRoleEnum.MSSP.toLowerCase() ||
        this.currentUserRole.name.toLowerCase() === AppLevelRoleEnum.SUPER_ENTITY_LEADER ||
        this.currentUserRole.name.toLowerCase() === AppLevelRoleEnumBnB.USER_ADMINISTRATOR.toLowerCase() ||
        this.currentUserRole.name.toLowerCase() === AppLevelRoleEnum.ENTITY_LEADER.toLowerCase())
    );
  }

  // Vendors belong to the third-party screen: their role and their users stay out of first-party lists.
  // Read from the URL rather than a field so it cannot depend on ngOnInit ordering.
  private get isVendorRoleAllowed(): boolean {
    return this.router.url.includes('third-party');
  }

  async setPrivileges(roles?) {
    const rolePrivileges = await this.userSettingService.filterRolesByUser(roles);
    if (rolePrivileges) {
      this.allRoles = rolePrivileges?.privileges ? [...rolePrivileges.privileges] : [];
      if (!this.isVendorRoleAllowed) {
        this.allRoles = this.allRoles.filter(role => role?.name?.toLowerCase() !== AppLevelRoleEnum.VENDOR);
      }
      this.entityService.roles = this.allRoles;
      this.userService.roles = this.allRoles;
      this.roleFilterOptions = [{ id: 'all', name: 'all' }, ...this.allRoles];
      this.roleFilter = { id: 'all', name: 'all' };
      this.customRoles = rolePrivileges.privileges.filter(role => UtilsService.isDefined(role.entityId));
      this.entityService.customRoles = this.customRoles;
      this.userService.customRoles = this.customRoles;
      this.selectedRole = null;
      this.roleSelected = false;
      // Copy: splicing/filtering a reference to UserService.defaultRoles mutates the shared role cache,
      // which then behaves differently on a refresh (fresh cache) than on in-app navigation.
      this.defaultRoles = [...this.userService.defaultRoles];

      const entityData = await this.rootEntityContextService.getRootEntityById(this.entityId);
      // if items array does not exist, consider Policy Management as enabled by default
      const policyManagementItem = entityData.solutionStatus?.items?.find(item => item.key === 'policyManagement');
      const policyManagementEnabled = !entityData.solutionStatus?.items ? true : policyManagementItem?.enabled;

      // only filter out Policy Manager role if policy management is disabled AND current user is not a Policy Manager
      if (!policyManagementEnabled && !this.isPolicyManager) {
        this.defaultRoles = this.defaultRoles.filter(
          role => role.name?.toLowerCase() !== AppLevelRoleEnum.POLICY_MANAGER
        );
      }

      // if items array does not exist, consider Regulatory Watch as enabled by default
      const regulatoryWatchItem = entityData.solutionStatus?.items?.find(item => item.key === 'regulatoryWatch');
      const regulatoryWatchEnabled = !entityData.solutionStatus?.items ? true : regulatoryWatchItem?.enabled;

      // only filter out regulation manager role if regulatory watch is disabled AND current user is not a regulation manager
      if (!regulatoryWatchEnabled && !this.isRegulationManager) {
        this.defaultRoles = this.defaultRoles.filter(
          role => role.name?.toLowerCase() !== AppLevelRoleEnum.REGULATION_MANAGER
        );
      }
      if (!this.isVendorRoleAllowed) {
        this.defaultRoles = this.defaultRoles.filter(role => role?.name?.toLowerCase() !== AppLevelRoleEnum.VENDOR);
      }
    }
  }
  checkIfEllipsis(element: any): void {
    this.showColumnTooltip = element.scrollWidth > element.clientWidth;
  }
  selectRole(event, index, roleType: string = UsersSettingConstant.custom): void {
    this.roleSelected = true;
    if (roleType.toLowerCase() === UsersSettingConstant.default) {
      this.selectedRole = this.defaultRoles[index];
      this.isDefaultRole = true;
    } else {
      this.selectedRole = this.customRoles[index];
      this.isDefaultRole = false;
    }
    this.showRolePermission = true;
    // this.permissions = this.customRoles[index].screenPermissions;
  }

  async deleteCustomRole(role: any): Promise<void> {
    // check either this
    const roleDeleteable = await this.userSettingService.isRoleDeleteAble(role.id);
    if (!roleDeleteable) {
      this.toastrService.error('You Can not delete ' + role.name + ' some users are there against this role');
      return;
    }
    const modalRef = this.modalService.open(DeleteModalComponent, this.ngbModalDeleteUserOptions);

    modalRef.componentInstance.titleText = '';
    modalRef.componentInstance.show2ndConfirmText = 'All your data will be lost';
    modalRef.componentInstance.removeLabelText = 'Custom Role';
    modalRef.componentInstance.deleteEntityModal = true;
    modalRef.componentInstance.svgName = 'trash-icon-3';

    modalRef.componentInstance.deleteFramework.subscribe(async (deleteConfirm: boolean) => {
      if (deleteConfirm) {
        // the tile stands as a skeleton until the delete comes back, rather than vanishing while
        // the request is still in flight
        this.pendingRoleId = role.id;
        try {
          const deleted = await this.userSettingService.deleteRoles(role.id);
          if (!deleted) {
            // the role is still there, so leave its tile in the list
            return;
          }
          let ind = this.customRoles.findIndex(customRole => customRole.id === role.id);
          let res = ind > -1 ? this.customRoles.splice(ind, 1) : null;
          ind = this.allRoles.findIndex(r => r.id === role.id);
          res = ind > -1 ? this.allRoles.splice(ind, 1) : null;
          ind = this.roleFilterOptions.findIndex(r => r?.name === role?.name);
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          res = ind > -1 ? this.roleFilterOptions.splice(ind, 1) : null;
          this.showRolePermission = false;
        } finally {
          this.clearPendingRole();
        }
      }
    });

    this.closeModalInstance = modalRef;
  }

  showScrenPermission(): void {
    this.showRolePermission = true;
  }

  async getEntitiesMap(): Promise<Map<string, GetEntityQuery>> {
    const entitiesMap: Map<string, GetEntityQuery> = new Map();
    const entityList = await this.rootEntityContextService.getSubEntities();
    this.vendorsList = await this.thirdPartyService.getExtendVendorsListByParentId(this.entityId);
    this.entityList = entityList;
    entityList.forEach(entity => (entitiesMap[entity.id] = entity));
    return entitiesMap;
  }

  async getAllUsers(): Promise<UserItem[]> {
    const entityNVendorIds: string[] = Object.keys(this.entities);
    entityNVendorIds.push(...this.vendorsList.map(v => v.id?.toString()));
    const data = await this.userService.getAllUsersForEntityWithRoleId(
      this.entityId,
      entityNVendorIds,
      this.currentUserRole,
      true
    );
    const { usersList, roles } = data;
    this.allRoles = roles;

    this.roleFilterOptions = ['all', ...this.allRoles];

    return usersList.map(item => this.addAccessLevel(item));
  }

  async getGlobalAllUsers(): Promise<UserItem[]> {
    const usersList = await this.userService.getUsersByDomain();
    this.allRoles = this.userService.getSortedRolesForBNB(this.allRoles);
    this.customRoles = this.allRoles.filter(role => role.defaultOrEntityId !== UsersSettingConstant.default);
    this.defaultRoles = this.allRoles.filter(role => role.defaultOrEntityId === UsersSettingConstant.default);
    // this.roleFilterOptions = ['all', ...this.allRoles];
    // this.roleFilter = 'all';
    this.roleFilterOptions = [{ id: 'all', name: 'all' }, ...this.allRoles];
    this.roleFilter = { id: 'all', name: 'all' };
    if (usersList && !!usersList.length) {
      const finalList = usersList
        .map(item => {
          if (item) {
            return this.addAccessLevel(item);
          }
        })
        .filter(user => {
          const index = this.allRoles.findIndex(rol => rol?.id === user?.user?.roleId);
          if (index !== -1) {
            return user;
          }
        });
      return finalList;
    } else {
      return [];
    }
  }

  /**
   *
   * @returns the list of custom as well as built in roles based on custom users.
   */
  updateCustomRolesList(isRootAccess: boolean, customRole: GetRoleQuery): void {
    // If true
    // Gets the custom roles not having the root access.
    if (isRootAccess) {
      this.customRoles = this.customRoles.filter(role => !role.isRootEntityAccess);
      this.customRoles.push(customRole);
      this.customRoles.push(this.defaultRoles.find(role => role.name === AppLevelRoleEnum.PARTICIPANT));
      this.customRoles.push(this.defaultRoles.find(role => role.name === AppLevelRoleEnum.SUBENTITY_LEADER));
    } else {
      this.customRoles = [];
      this.customRoles.push(customRole);
      this.customRoles.push(this.defaultRoles.find(role => role.name === AppLevelRoleEnum.PARTICIPANT));
    }
    this.allRoles = this.customRoles;
    this.roleFilterOptions = [{ id: 'all', name: 'all' }, ...this.allRoles];
  }

  async getAssignedUsers(): Promise<any> {
    // NOTE: previously fetched AssessmentsByChildId / AssessmentsByRootId into `this.assessments`,
    // but that value is never read anywhere (component TS or template). The real per-user assignment
    // data comes from updateUserAssignments() (getCompletions), so the query was a dead network call
    // on every load — removed.
    return await this.updateUserAssignments();
  }

  /**
   */
  async getAssignedUsersForGlobal(users: any): Promise<any> {
    const usersMap = {};
    let completions = [];
    try {
      completions = await Promise.all(
        users.map(async user =>
          (await this.customAPI.CompletionByUser(user?.user?.id)).items.map(item => ({
            ...item,
          }))
        )
      );
    } catch (e) {
      console.log('Cannot Fetch the assigned users ===> ', e);
      Promise.reject();
    }

    const completionData = completions.flat(1).filter((d: any) => UtilsService.isDefined(d.user));
    return {
      data: Object.values(
        completionData.reduce((obj, { user, ...completion }: any) => {
          if (user) {
            usersMap[user.id] = true;
            return {
              ...obj,
              [user.id]: {
                user: this.getUser(user),
                access: [AppLevelRoleEnum.ADMIN, AppLevelRoleEnum.MSSP].some(item => item === user.role)
                  ? 'All'
                  : this.entities[completion.subEntityId]?.name,
                entities: [
                  ...(obj && obj[user.id] && obj[user.id].entities ? obj[user.id].entities : []),
                  {
                    ...completion,
                    assignments: JSON.parse(completion.assignmentMap),
                    access: [AppLevelRoleEnum.ADMIN, AppLevelRoleEnum.MSSP].some(item => item === user.role)
                      ? 'All'
                      : this.entities[completion.subEntityId]?.name,
                  },
                ],
              },
            };
          }
        }, {})
      ),
      map: usersMap,
    };
  }

  async fetchAllUsers(): Promise<void> {
    try {
      const canUseGlobalUserList =
        this.isGlobalUserSetting &&
        (this.isBnb || this.isBeecher || this.isMidMarket) &&
        !this.entityId &&
        !this.userService.isSuperEntityLeader();
      this.allUsers = canUseGlobalUserList ? await this.getGlobalAllUsers() : await this.getAllUsers();
      this.assignedUsers =
        this.isGlobalUserSetting && (this.isBnb || this.isBeecher || this.isMidMarket)
          ? await this.getAssignedUsersForGlobal(this.allUsers)
          : await this.getAssignedUsers();
      //* Filter out root-scoped leaders who do not have the current root entity ID in entityIds.
      //* The fetch filter also matches users with no entityIds at all, so these roles need the guard.
      if (this.entityId) {
        const entityId = this.entityId;
        const rootScopedRoles: string[] = [AppLevelRoleEnum.ENTITY_LEADER, AppLevelRoleEnum.SUPER_ENTITY_LEADER];
        this.allUsers = this.allUsers.filter(({ user }) => {
          if (!user?.role?.name) {
            return true;
          }
          const isRootScopedLeader = rootScopedRoles.includes(user.role.name.trim().toLowerCase());
          return !isRootScopedLeader || user.entityIds?.includes(entityId);
        });
      }
      if (!this.isVendorRoleAllowed) {
        const vendorRoleId = this.userService.getRoleId(AppLevelRoleEnum.VENDOR);
        if (vendorRoleId) {
          this.allUsers = this.allUsers.filter(({ user }) => user?.roleId !== vendorRoleId);
        }
      }
      this.updateUsers();
    } catch (e) {
      this.logger.error(e);
      this.toastrService.error('UsersSettingsComponent - Error: ', e);
    }
  }

  /**
   * Not In use anymore.
   * This function populates the filterOptions.
   */
  populateRoleFilter() {
    const index = this.roleFilterOptions.indexOf(RoleEnum.LEADER);
    const roleNames = [...this.roleFilterOptions];
    if (index > -1) {
      roleNames.splice(index, 1, ...[this.ENTITY_LEADER_ROLE, this.SUBENTITY_LEADER_ROLE]);
    }
    if (this.currentUserRole.name.toLowerCase() === RoleEnum.LEADER.toLowerCase()) {
      const leader = this.getUser(this.currentUser);
      this.roleFilterOptions = UtilsService.getRoleMapped(leader.role, roleNames);
    } else {
      this.roleFilterOptions = UtilsService.getRoleMapped(this.currentUserRole.name, roleNames);
    }
  }

  addAccessLevel(user): any {
    // temporary getting the role of the user then will be updated later after adding connection.
    // If condition is used for attaching the role of the currently logged in User for handling the case of E.L / S.E.L
    if (user.roleId === this.currentUser.roleId) {
      user.role = this.userService.getCurrentRole();
    } else {
      user.role = this.allRoles.find(role => role?.id?.toLowerCase() === user?.roleId?.toLowerCase());
    }
    return {
      user: this.getUser(user),
      access:
        [
          AppLevelRoleEnum.ADMIN,
          AppLevelRoleEnum.MSSP,
          AppLevelRoleEnum.ENTITY_LEADER,
          AppLevelRoleEnumBnB.ENTERPRISE,
          AppLevelRoleEnumBnB.DIVISION_LEADER,
          AppLevelRoleEnumBnB.REGION_LEADER,
          AppLevelRoleEnumBnB.USER_ADMINISTRATOR,
          AppLevelRoleEnumBnB.BUSINESS_ENTITY_ADMIN,
        ].some(role => role === user.role?.name) ||
        // case handling for custom role with root entity access.
        (user && user.role && user.role.entityIds && user.role.isRootEntityAccess) // If the custom role has the root entity access.
          ? 'All'
          : (user.entityIds && this.entities[user.entityIds[0]]) || // handling the case of the subEntity.
              (user && user.role && user.role.entityIds && !user.role.isRootEntityAccess) // handling the case of the subEntity custom.
            ? this.entities[user.entityIds ? user.entityIds[0] : user.role.entityIds[0]]?.name
            : { [AppLevelRoleEnum.ADMIN]: 'All', [AppLevelRoleEnum.MSSP]: 'All Clients' }[user?.role?.name],
    };
  }

  addUserToList(user: any) {
    this.mapUserProgress(this.addAccessLevel(user));
    this.filteredUserList = [...this.users[this.status]];
    this.filteredUserList = this.userService.filterUserList(this.filteredUserList);
  }

  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  mapUserProgress = (questionCompletionObj: any & { assignments?: Array<any> }): void => {
    const user = questionCompletionObj.user;
    this.users.all = [questionCompletionObj, ...this.users.all];

    if (!user.isCognitoUser) {
      this.users[QuestionnaireProgressEnum.pending] = [
        questionCompletionObj,
        ...this.users[QuestionnaireProgressEnum.pending],
      ];
    } else {
      if (!questionCompletionObj.assessment || !questionCompletionObj.completedQuestions) {
        this.users[QuestionnaireProgressEnum.enrolled] = [
          questionCompletionObj,
          ...this.users[QuestionnaireProgressEnum.enrolled],
        ];
      } else if (questionCompletionObj.completedQuestions < questionCompletionObj.totalQuestions) {
        this.users[QuestionnaireProgressEnum.inProcess] = [
          questionCompletionObj,
          ...this.users[QuestionnaireProgressEnum.inProcess],
        ];
      } else if (questionCompletionObj.completedQuestions === questionCompletionObj.totalQuestions) {
        this.users[QuestionnaireProgressEnum.completed] = [
          questionCompletionObj,
          ...this.users[QuestionnaireProgressEnum.completed],
        ];
      }
    }
  };

  getUser(user): GetUserQuery {
    return {
      ...user,
      role:
        user.role !== AppLevelRoleEnum.ENTITY_LEADER
          ? user.role
          : user.entityId === this.entityId
            ? this.ENTITY_LEADER_ROLE
            : this.SUBENTITY_LEADER_ROLE,
    };
  }

  handleEditMode(): void {
    this.isEditMode = !this.isEditMode;
    if (this.isEditMode) {
      this.userSettingService.setIsEditMode(true);
    } else {
      // User hit the X (cancel) — revert any locally staged Regulatory Watch Admin changes.
      if (this._pendingRegulatoryWatchSnapshot.size > 0) {
        this._pendingRegulatoryWatchSnapshot.forEach((originalPrivileges, userId) => {
          const idx = this.filteredUserList.findIndex(u => u.user?.id === userId);
          if (idx >= 0) {
            this.filteredUserList[idx].user.privileges = originalPrivileges;
          }
        });
        this._pendingRegulatoryWatchSnapshot.clear();
      }
      this.userSettingService.cancelEditMode();
    }
  }

  /**
   * Which clear action the no-results panel offers: a search term wins over the Role/Status
   * filters, and null means the list is genuinely empty rather than filtered down to nothing.
   */
  get emptyClearMode(): 'search' | 'filters' | null {
    if (this.searchText) {
      return 'search';
    }
    return this.role !== 'all' || this.status !== 'all' ? 'filters' : null;
  }

  /** Role/Status get the same brief in-process window as a search, matching Policy Management. */
  onFilterChanged(filterType: string, newFilter: string): void {
    if (this.filterApplyTimer) {
      clearTimeout(this.filterApplyTimer);
    }
    this.isSearching = true;
    this.filterApplyTimer = setTimeout(() => {
      this.filterApplyTimer = null;
      this.filterChanged(filterType, newFilter);
      this.isSearching = false;
    }, this.SEARCH_APPLY_MS);
  }

  /** Clear Filters on the no-results panel: reset Role and Status and rebuild the list. */
  clearFilters(): void {
    if (this.filterApplyTimer) {
      clearTimeout(this.filterApplyTimer);
      this.filterApplyTimer = null;
    }
    this.isSearching = false;
    this.roleFilter = { id: 'all', name: 'all' };
    this.statusFilter = { id: 'all', name: 'all' };
    this.role = 'all';
    this.status = 'all';
    // rebuilding through the search branch re-applies any term that is still in the box
    this.filterChanged('search', this.searchText);
  }

  /** Runs the search on Enter, holding the in-process panel open for the brief apply window. */
  onSearch(): void {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    // Enter on an empty box is a clear, not a search, so it never raises the in-process panel
    this.isSearching = !!this.searchInputText.trim();
    this.searchDebounceTimer = setTimeout(() => {
      this.searchDebounceTimer = null;
      this.searchText = this.searchInputText.trim();
      this.filterChanged('search', this.searchText);
      this.isSearching = false;
    }, this.SEARCH_APPLY_MS);
  }

  /** Emptying the box is a reset, not a query, so it clears without waiting for Enter. */
  onSearchInput(): void {
    if (!this.searchInputText.trim() && (this.searchText || this.isSearching)) {
      this.clearSearch();
    }
  }

  /** Clear Search on the no-results panel: drop the term and restore the list. */
  clearSearch(): void {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
    this.searchInputText = '';
    this.searchText = '';
    this.isSearching = false;
    this.filterChanged('search', this.searchText);
  }

  filterChanged(filterType: string, newFilter: string): void {
    if (!newFilter) {
      newFilter = 'all';
    }
    if (filterType === 'status') {
      // `status` is the id every list lookup keys on; `statusFilter` stays the {id, name} object
      // the dropdown is bound to, or cygov-select loses the label it reads through bindLabel
      this.status = newFilter;
      this.filteredUserList = [...this.users[this.status]];
      this.filteredUserList =
        this.searchText.length < 2
          ? this.filteredUserList
          : [...this.filteredUserList].filter(({ user }) =>
              user.name.toLowerCase().includes(this.searchText.toLowerCase())
            );
      this.filteredUserList =
        this.role === 'all'
          ? this.filteredUserList
          : [...this.filteredUserList].filter(({ user }) => user.roleId === this.role);

      this.lowerTabsContentOptions[0].label = this.filteredUserList.length + ' Users';
    }

    if (filterType === 'search') {
      this.filteredUserList =
        newFilter.length < 2
          ? [...this.users[this.status]]
          : [...this.users[this.status]].filter(
              ({ user }) =>
                user.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
                user.email.toLowerCase().includes(this.searchText.toLowerCase())
            );
      this.filteredUserList =
        this.role === 'all'
          ? this.filteredUserList
          : [...this.filteredUserList].filter(({ user }) => user.roleId === this.role);
    }

    if (filterType === 'role') {
      this.role = newFilter;
      this.filteredUserList =
        this.role === 'all'
          ? [...this.users[this.status]]
          : [...this.users[this.status]].filter(({ user }) => user.roleId === this.role);
      this.filteredUserList =
        this.searchText.length < 2
          ? this.filteredUserList
          : [...this.filteredUserList].filter(({ user }) =>
              user.name.toLowerCase().includes(this.searchText.toLowerCase())
            );
      this.sorting(UsersSettingConstant.name, UsersSettingConstant.ascending);
      this.lowerTabsContentOptions[0].label = this.filteredUserList.length + ' Users';
    }
  }

  onUserSelected($event: (GetQuestionnaireCompletionQuery & { assignments?: Array<any> })[]): void {
    this.selectedUsers = $event;
  }

  sortData(tableHeader: TableHeader): void {
    const type: string = tableHeader.sortDirection;
    const col: string = tableHeader.value;

    // temporary adding the condition will be removed after connection is done
    if (tableHeader && tableHeader?.name?.toLowerCase() === 'role') {
      this.mapUserRole();
    }
    if (this.previousSort !== '') {
      this.sortOptions[this.previousSort] = 'na';
    }
    this.previousSort = col;
    this.sortOptions[col] = type;

    this.filteredUserList.sort(function (a, b) {
      if (col === 'artifacts') {
        return 0;
      }
      if (col === 'name' || col === 'role' || col === 'email') {
        const nameA = a.user[col].toUpperCase();
        const nameB = b.user[col].toUpperCase();
        if (nameA < nameB) {
          if (type === 'asc') {
            return -1;
          } else {
            return 1;
          }
        }

        if (nameA > nameB) {
          if (type === 'asc') {
            return 1;
          } else {
            return -1;
          }
        }
        return 0;
      }

      if (col === 'access') {
        const accessA = (a.access || '').toUpperCase();
        const accessB = (b.access || '').toUpperCase();

        if (accessA < accessB) {
          return type === 'asc' ? -1 : 1;
        }

        if (accessA > accessB) {
          return type === 'asc' ? 1 : -1;
        }

        return 0;
      }

      const valueA = a.user[col];
      const valueB = b.user[col];
      if (type === 'asc') {
        return valueA - valueB;
      } else {
        return valueB - valueA;
      }
    });

    if (col === 'artifacts') {
      this.filteredUserList.sort((a, b) => {
        const valueA = this.getArtifactsSortValue(a).toUpperCase();
        const valueB = this.getArtifactsSortValue(b).toUpperCase();
        if (valueA < valueB) {
          return type === 'asc' ? -1 : 1;
        }
        if (valueA > valueB) {
          return type === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    // Adding filtered list
    this.filteredUserList = JSON.parse(JSON.stringify(this.filteredUserList));
  }

  getArtifactsSortValue(userItem: any): string {
    const roleName = userItem?.user?.role?.name?.toLowerCase() || '';
    const adminRoles = [
      AppLevelRoleEnum.ADMIN,
      AppLevelRoleEnum.MSSP,
      AppLevelRoleEnum.SUPER_ENTITY_LEADER,
      AppLevelRoleEnum.ENTITY_LEADER,
    ];
    const subEntityRoles = [AppLevelRoleEnum.SUBENTITY_LEADER, AppLevelRoleEnum.PARTICIPANT];

    if (adminRoles.includes(roleName as AppLevelRoleEnum)) {
      return 'ALL';
    }

    if (subEntityRoles.includes(roleName as AppLevelRoleEnum)) {
      const artifactSubEntities: string[] = userItem?.user?.artifactSubEntities || [];
      const entityHash = this.entities as any;
      const names = artifactSubEntities
        .map(id => entityHash?.[id]?.name || this.childEntities?.find(entity => entity?.id === id)?.name)
        .filter(Boolean);
      return names.length ? names.join(', ') : '-';
    }

    return '';
  }

  /**
   * temporary method for sorting the list of users according to the roles.
   */
  mapUserRole(): void {
    // mapping the user roles from roles.
    this.filteredUserList.map(filteredUser => {
      filteredUser.user.role = this.userService.hashRoles[filteredUser.user.roleId].name;
    });
  }

  sorting(col: string, type: string): void {
    this.filteredUserList.sort(function (a, b) {
      if (col === UsersSettingConstant.name) {
        const nameA = a.user[col].toUpperCase();
        const nameB = b.user[col].toUpperCase();
        if (nameA < nameB) {
          if (type === UsersSettingConstant.ascending) {
            return -1;
          } else {
            return 1;
          }
        }

        if (nameA > nameB) {
          if (type === UsersSettingConstant.ascending) {
            return 1;
          } else {
            return -1;
          }
        }
        return 0;
      } else {
        const valueA = a.user[col];
        const valueB = b.user[col];
        if (type === UsersSettingConstant.ascending) {
          return valueA - valueB;
        } else {
          return valueB - valueA;
        }
      }
    });
  }

  getFilteredUsers() {
    return this.users[this.status];
  }

  /**
   * ******************** Actions Functionality *********************
   */

  /**
   * Open a modal to Add New User
   */
  addNewUser(): void {
    this.userSettingService.setIsAddNewUSerModalOpened(true);
    const modalRef = this.modalService.open(AddUserSettingsModalComponent, {
      size: 'lg',
      windowClass: 'add-user-modal custom-user-settings-add-user',
      backdropClass: 'custom-user-settings-add-user-backdrop',
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.roles = this.allRoles;
    modalRef.componentInstance.currentEntityId = this.entityId;
    modalRef.componentInstance.modalResult.subscribe(async (newUser: CreateUserInput) => {
      try {
        modalRef.close();
        await this.addUser(newUser);
      } catch (e) {
        console.log(e);
      }
    });

    this.closeModalInstance = modalRef;
  }
  /**
   *  add new User to database and update the Current Users list here
   * @param newUser is type of User Object
   */
  async addUser(newUser: CreateUserInput): Promise<void> {
    if (newUser) {
      this.isCreatingUser = true;
      try {
        this.tmpRole = newUser.role;
        newUser.role = RoleEnum.CUSTOM; // Temporary adding the CUSTOM enum to every user, will be removed later.
        this.toastrService.info('adding user...');
        let user = await this.authService.addNewParticipant(newUser);
        const newUserBody = await user.body.json();
        const tempUser = newUserBody.data;
        user = { entityIds: newUser?.entityIds, artifactSubEntities: newUser?.artifactSubEntities, ...tempUser };
        this.addUserToList(user);
        this.toastrService.success('User added');
      } catch (e) {
        const message = UtilsService.msgFromError(e);
        this.toastrService.error(message);
      } finally {
        // the real row has taken the skeleton's place on success, and on failure nothing was added
        this.isCreatingUser = false;
      }
    }
  }
  /**
   * this update the a Single user at time ( old Functionality not in use)
   * @param data
   */
  async updateUser(data: any): Promise<void> {
    if (data) {
      const user = {
        id: data?.id,
        name: data.name,
        phone: data.phone,
        entityId: data.entityId,
        role: data.role,
      };
      try {
        this.toastrService.info('updating user...');
        // Updating user via API
        await this.customAPI.UpdateUser(user);
        // Updating user in the list on client side
        const index = this.users[this.status].findIndex(item => item.user?.id === user?.id);
        this.users[this.status][index] = { ...this.users[this.status][index], user };
      } catch (e) {
        const message = UtilsService.msgFromError(e);
        this.toastrService.error(message);
      }
    }
  }
  /**
   * Returns true only when at least one selected user has the Admin, Entity Leader, or MSSP role,
   * which is the condition required to enable the Regulatory Watch Admin button.
   */
  isMsspSelected(): boolean {
    if (!this.selectedUsers || !this.selectedUsers.length) {
      return false;
    }
    const eligibleRoles = [
      AppLevelRoleEnum.ADMIN.toLowerCase(),
      AppLevelRoleEnum.ENTITY_LEADER.toLowerCase(),
      AppLevelRoleEnum.SUPER_ENTITY_LEADER.toLowerCase(),
      AppLevelRoleEnum.MSSP.toLowerCase(),
      AppLevelRoleEnum.SUPER_ENTITY_LEADER.toLowerCase(),
    ];
    return this.selectedUsers.some(item => {
      const role = item?.user?.role as any;
      const roleName = (role?.name ?? role)?.toString()?.toLowerCase() ?? '';
      return eligibleRoles.includes(roleName);
    });
  }

  /**
   * This function update all the selected Users whose data is changed all at a time
   */
  async onRegulatoryWatchAdmin(): Promise<void> {
    if (!this.selectedUsers || !this.selectedUsers.length) {
      this.toastrService.error('No user selected');
      return;
    }

    const allowedRoles = [
      AppLevelRoleEnum.ADMIN.toLowerCase(),
      AppLevelRoleEnum.ENTITY_LEADER.toLowerCase(),
      AppLevelRoleEnum.MSSP.toLowerCase(),
      AppLevelRoleEnum.SUPER_ENTITY_LEADER.toLowerCase(),
    ];
    const ineligibleUsers = this.selectedUsers.filter(item => {
      const role = item?.user?.role as any;
      const roleName = (role?.name ?? role)?.toString()?.toLowerCase() ?? '';
      return !allowedRoles.includes(roleName);
    });

    if (ineligibleUsers.length) {
      this.toastrService.warning('Regulatory Watch Admin privilege is only allowed for Entity Leader and MSSP roles');
      return;
    }

    // Update privileges locally — the API call will happen when the user clicks SAVE.
    this.selectedUsers.forEach(item => {
      const user = item.user as any;
      const currentPrivileges: string[] = user.privileges ?? [];
      const hasPrivilege = currentPrivileges.includes('regulatory-watch-admin');
      const updatedPrivileges = hasPrivilege
        ? currentPrivileges.filter(p => p !== 'regulatory-watch-admin')
        : [...currentPrivileges, 'regulatory-watch-admin'];

      // Update filteredUserList in place so saveUpdatedUsers picks up the new privileges.
      const idx = this.filteredUserList.findIndex(u => u.user?.id === user.id);
      if (idx >= 0) {
        // Save original privileges so we can revert if the user cancels.
        if (!this._pendingRegulatoryWatchSnapshot.has(user.id)) {
          this._pendingRegulatoryWatchSnapshot.set(user.id, [...currentPrivileges]);
        }
        // Mutate directly on the existing object so the shared reference in userListToShow
        // (inside user-list child) reflects the change without triggering ngOnChanges
        // (which resets isSelected on all rows).
        this.filteredUserList[idx].user.privileges = updatedPrivileges;
        // Pass only UpdateUserInput-compatible fields to avoid GraphQL validation errors.
        const updatePayload = {
          id: user.id,
          name: user.name,
          email: user.email,
          role: user.role,
          roleId: user.roleId,
          isViewOnly: user.isViewOnly,
          phone: user.phone,
          entityId: user.entityId,
          entityIds: user.entityIds,
          domain: user.domain,
          privileges: updatedPrivileges,
          regulationDomains: user.regulationDomains,
          artifactSubEntities: user.artifactSubEntities,
          lightTheme: user.lightTheme,
          regulationMonitoringFilters: user.regulationMonitoringFilters,
          isSelected: true,
        };
        // Ensure user appears in the updatedUsersList so SAVE processes them.
        this.userSettingService.addUserToUpdateList(updatePayload, true);
      }
    });

    // Enter edit mode so the SAVE button is visible.
    if (!this.isEditMode) {
      this.isEditMode = true;
      this.userSettingService.setIsEditMode(true);
    }
  }

  async saveUpdatedUsers(): Promise<void> {
    const users = this.userSettingService.getUpdatedUsersList();
    // To check how many users are selected
    if (users && users.length) {
      const selectedUsers = [];
      let isValid = true;
      users.filter(item => {
        const userItem = JSON.parse(JSON.stringify(item));
        if (userItem.isSelected) {
          userItem.roleId = typeof userItem.role === 'string' ? userItem.role : userItem.role?.id;
          userItem.role = 'CUSTOM';
          if (userItem?.permission !== undefined && userItem?.permission !== null) {
            userItem.isViewOnly = userItem.permission.toLowerCase() !== 'edit';
          }
          const tmpRole = this.allRoles.find(role => role?.id === userItem.roleId);
          if (tmpRole?.name === AppLevelRoleEnum.ENTITY_LEADER) {
            userItem.entityId = this.entityId;
            userItem.entityIds = [this.entityId];
          } else if (tmpRole.name === AppLevelRoleEnumBnB.BUSINESS_ENTITY_ADMIN) {
            userItem.entityId =
              userItem && userItem.entityIds && userItem.entityIds.length ? userItem.entityIds[0] : null;
          } else if (tmpRole?.name === AppLevelRoleEnum.SUPER_ENTITY_LEADER) {
            // Super Entity Leader keeps its multiple root entities; entityId stays the first of them
            // (the temporary single-entity field every role still carries).
            if (!(userItem.entityIds && userItem.entityIds.length)) {
              this.toastrService.error('Please select at least one root entity for ' + tmpRole.name);
              isValid = false;
              return;
            }
            userItem.entityId = userItem.entityIds[0];
          } else if (
            tmpRole &&
            (tmpRole.name === AppLevelRoleEnum.SUBENTITY_LEADER || tmpRole.name === AppLevelRoleEnum.PARTICIPANT)
          ) {
            userItem.entityId = this.entityId;
            if (!(userItem.entityIds && userItem.entityIds.length)) {
              this.toastrService.error('Please select at least one sub entity for ' + tmpRole.name);
              isValid = false;
              return;
            }
          } else {
            userItem.entityId = null;
            userItem.entityIds = null;
          }
          delete userItem.isSelected;
          delete userItem.permission;
          // Only fall back to filteredUserList when privileges were NOT explicitly set
          // (e.g. by removeRegulatoryWatchPrivilege). If they were set, honour that value.
          if (userItem.privileges === undefined || userItem.privileges === null) {
            const matchingUser = this.filteredUserList.find(u => u.user?.id === userItem.id);
            if (matchingUser) {
              userItem.privileges = (matchingUser.user as any).privileges ?? [];
            }
          }
          selectedUsers.push(userItem);
        }
      });
      if (!isValid) {
        return;
      }
      const anyEmptyRoleName = selectedUsers.find(u => !u.name || (u.name && u.name.trim() === ''));
      if (selectedUsers && !!selectedUsers.length && anyEmptyRoleName) {
        this.toastrService.error('Name cannot be empty');
      } else if (selectedUsers && selectedUsers.length) {
        const updatedUserIds = selectedUsers.map(user => user?.id);
        this.setUsersBusy(updatedUserIds, true);
        try {
          this.toastrService.info(`Updating ${pluralize('user', selectedUsers.length)}...`);
          let updatedUser;
          await Promise.all(
            selectedUsers.map(async user => {
              updatedUser = await this.customAPI.UpdateUser(user);
            })
          );
          if (updatedUser.statusCode === 401) {
            this.toastrService.error('User is not Authorized to perform this action');
            return;
          }
          this.afterUsersUpdate(selectedUsers);
          this._pendingRegulatoryWatchSnapshot.clear();
          this.isEditMode = false;
          this.userSettingService.setIsEditMode(false);
          this.toastrService.success('Selected Users are updated');
        } catch (e) {
          const message = UtilsService.msgFromError(e);
          this.toastrService.error(message);
        } finally {
          this.setUsersBusy(updatedUserIds, false);
        }
      } else {
        this.toastrService.error('No user selected to update');
      }
    } else {
      this.toastrService.error('No change found in any User data');
    }
  }

  /** Rows whose mutation is in flight; the set is replaced so the child sees a new reference. */
  private setUsersBusy(userIds: string[], busy: boolean): void {
    const next = new Set(this.busyUserIds);
    userIds.filter(Boolean).forEach(id => (busy ? next.add(id) : next.delete(id)));
    this.busyUserIds = next;
  }

  /**
   * update the users in Current Users List
   * @param updatedUsers is type of users list . the users that are updated
   */
  afterUsersUpdate(updatedUsers: any[]): void {
    this.selectedUsers = [];
    updatedUsers.map(updatedUser => {
      const index = this.filteredUserList.findIndex(u => u?.user?.id === updatedUser?.id);
      const userListIndex = this.users.all.findIndex(u => u?.user?.id === updatedUser?.id);
      if (index >= 0 && userListIndex >= 0) {
        try {
          this.filteredUserList[index].user.name = updatedUser.name
            ? updatedUser.name
            : this.filteredUserList[index].user.name;
          // Finding the role on temporary basis will be removed after connection
          const isRoleUpdated = this.filteredUserList[index].user.roleId !== updatedUser.roleId;
          this.filteredUserList[index].user.role = updatedUser.roleId
            ? this.allRoles.find(role => role.id === updatedUser.roleId)
            : this.filteredUserList[index].user.role;
          this.filteredUserList[index].user.roleId = updatedUser.roleId
            ? this.allRoles.find(role => role?.id === updatedUser.roleId)?.id
            : this.filteredUserList[index].user.roleId;
          this.filteredUserList[index].user.phone = updatedUser.phone
            ? updatedUser.phone
            : this.filteredUserList[index].user.phone;
          // * set permission to updated permission
          // * due to ? usage it was assigning old value in some cases
          // * if isViewOnly was true befor and updated value was false
          // * it would fall in else case and previous true value was being assigned
          this.filteredUserList[index].user.isViewOnly = updatedUser.isViewOnly;
          this.filteredUserList[index].user.artifactSubEntities = updatedUser.artifactSubEntities
            ? updatedUser.artifactSubEntities
            : this.filteredUserList[index].user.artifactSubEntities;
          if (updatedUser.privileges !== undefined) {
            this.filteredUserList[index].user.privileges = updatedUser.privileges;
          }
          this.filteredUserList[index].isSelected = false;
          this.filteredUserList[index].role = this.filteredUserList[index].user.role;
          // update the user List as well.
          this.users[this.status][userListIndex].user.name = updatedUser.name
            ? updatedUser.name
            : this.users[this.status][userListIndex].user.name;
          this.users[this.status][userListIndex].user.role = updatedUser.roleId
            ? this.allRoles.find(role => role.id === updatedUser.roleId)
            : this.users[this.status][userListIndex].user.role;
          this.users[this.status][userListIndex].user.roleId = updatedUser.roleId
            ? this.allRoles.find(role => role?.id === updatedUser.roleId)?.id
            : this.users[this.status][userListIndex].user.roleId;
          this.users[this.status][userListIndex].user.phone = updatedUser.phone
            ? updatedUser.phone
            : this.users[this.status][userListIndex].user.phone;
          this.users[this.status][userListIndex].user.isViewOnly = updatedUser.isViewOnly;
          this.users[this.status][userListIndex].user.artifactSubEntities = updatedUser.artifactSubEntities
            ? updatedUser.artifactSubEntities
            : this.users[this.status][userListIndex].user.artifactSubEntities;
          if (updatedUser.privileges !== undefined) {
            this.users[this.status][userListIndex].user.privileges = updatedUser.privileges;
          }
          this.users[this.status][userListIndex].role = this.users[this.status][userListIndex].user.role;
          this.userSettingService.updateIsSelected(this.filteredUserList[index]);

          if (!(this.role === 'all') && isRoleUpdated) {
            this.filteredUserList = this.filteredUserList.filter(u => u?.user?.id !== updatedUser?.id);
          }
        } catch (err) {
          this.toastrService.error('Something went wrong!');
        }
      }
    });
    // Close edit mode after a successful save — use setIsEditMode (not handleEditMode/cancelEditMode)
    // so user-item components do NOT revert their locally applied privilege changes.
    this.isEditMode = false;
    this.userSettingService.setIsEditMode(false);
  }

  /**
   * This function will open the Modal and in modal ask for confirmation to delete the selected users
   *  this function is not in use after new delete pop-up
   */
  onClickDelete(): void {
    const modalRef = this.modalService.open(DeleteUserModalComponent, {
      centered: true,
      size: 'lg',
      windowClass: 'delete-modal',
      backdropClass: 'delete-backdrop-modal',
    });

    modalRef.componentInstance.modalResult.subscribe(async () => {
      try {
        await this.deleteUsers(this.selectedUsers);
        modalRef.close();
      } catch (e) {
        console.log(e);
      }
    });

    modalRef.componentInstance.users = this.selectedUsers;
    this.closeModalInstance = modalRef;
  }
  /**
   * Delete Users new Pop current in use
   */
  deleteUserPopup(): void {
    if (!(this.selectedUsers && this.selectedUsers.length)) {
      this.toastrService.error(' No user is selected');
      return;
    }
    const modalRef = this.modalService.open(DeleteModalComponent, this.ngbModalDeleteUserOptions);
    modalRef.componentInstance.titleText = '';
    modalRef.componentInstance.isFromUserSettings = true;
    modalRef.componentInstance.show2ndConfirmText = 'All your data will be lost';
    modalRef.componentInstance.removeLabelText =
      this.selectedUsers.length > 1 ? this.selectedUsers.length + ' Selected Users ' : this.selectedUsers[0].user.name;
    modalRef.componentInstance.deleteEntityModal = false;
    modalRef.componentInstance.removeFromText =
      this.selectedUsers.length > 1 ? ' and their data will be deleted' : ' and his/her data will be deleted';
    const selectedUsers = this.selectedUsers;
    modalRef.componentInstance.deleteFramework.subscribe(async (deleteConfirm: boolean) => {
      if (deleteConfirm) {
        try {
          const eligibleToDelete = [];

          for (const eachUser of selectedUsers || []) {
            if (!eachUser?.entities) {
              eligibleToDelete.push(eachUser);
            } else {
              for (const entity of eachUser.entities || []) {
                const filter = {
                  managerId: {
                    eq: eachUser.user.id,
                  },
                };

                const assessmentStandards = await this.customAPI.StandardFrameworksByAssessmentId(
                  entity.assessmentId,
                  null,
                  filter
                );
                const archivedAssessments = assessmentStandards.items.every(assessment => assessment.archived);

                if (archivedAssessments) {
                  eligibleToDelete.push(eachUser);
                } else {
                  this.toastrService.error(`${eachUser.user.name} cannot be deleted as it is the last manager`);
                }
              }
            }
          }

          this.selectedUsers = eligibleToDelete;
          this.tmpSelectedUsers = [...this.selectedUsers];
          this.checkForVendorUsers();
          this.tmpSelectedUsers = [...this.selectedUsers];
          // It will check if the deleting user is the last manager or not.
          // await this.checkFrameworkManagerUsers();
          if (this.selectedUsers && this.selectedUsers.length) {
            await this.deleteUsers(this.selectedUsers);
          }
        } catch (e) {
          console.log(e);
        }
      }
    });
    this.closeModalInstance = modalRef;
  }

  openRiskAiConfirmationModal($event) {
    const modalRef = this.modalService.open(DeleteModalComponent, this.ngbModalRiskConfirmOptions);
    modalRef.componentInstance.titleText = '';
    modalRef.componentInstance.isFromRiskAiConfonfirmation = true;
    modalRef.componentInstance.svgName = 'robot';
    modalRef.componentInstance.deleteFramework.subscribe(async (deleteConfirm: boolean) => {
      if (deleteConfirm) {
        this.isAIUpdateInProgress = true;
        this.aiData = {
          ...this.aiData,
          isActive: $event,
          userName: this.currentUser.name,
          date: Date.now(),
        };
        if (!this.aiData?.credits || this.aiData?.credits === 0) {
          this.aiData.credits = 100;
        }
        this.aiData.usedCredits = this.aiData?.usedCredits || 0;
        try {
          await this.customAPI.updateAICredits({
            id: this.entityId,
            AI: this.aiData,
            requestType: 'updateAICredits',
          });
          this.toastrService.success('AI features Activated Successfully');
        } catch (error) {
          console.log('error', error);
          this.toastrService.error('Unable to Activate  AI features');
        }
        this.isAIUpdateInProgress = false;
      }
    });
    modalRef.componentInstance.closeModal.subscribe(isClose => {
      this.aiData.isActive = isClose;
      this.userService.toggleStateChanged$.next(isClose);
    });

    this.closeModalInstance = modalRef;
  }

  async deActivateRiskAI($event) {
    this.isAIUpdateInProgress = true;
    this.aiData = {
      ...this.aiData,
      isActive: $event,
      userName: this.currentUser.name,
      date: Date.now(),
    };
    try {
      await this.customAPI.updateAICredits({
        id: this.entityId,
        AI: this.aiData,
        requestType: 'updateAICredits',
      });
      this.toastrService.success('AI features Deactivated Successfully');
      this.isAIUpdateInProgress = false;
    } catch (error) {
      console.log('error', error);
      this.toastrService.error('Unable to Deactivate AI features');
      this.isAIUpdateInProgress = false;
    }
  }

  openCreditPackageModal(header: TemplateRef<any>, content: TemplateRef<any>, footer: TemplateRef<any>) {
    const modalRef = this.modalService.open(ModalTemplateComponent, this.ngbModalOptionsConfirmation);
    const compInstance = modalRef.componentInstance;
    this.closeModalInstance = modalRef;
    compInstance.customizeHeader = true;
    compInstance.headerContentRef = header;
    compInstance.contentRef = content;
    compInstance.footerContentRef = footer;
  }

  /**
   * will get all frameworks against deleting user
   */
  async checkFrameworkManagerUsers(): Promise<void> {
    for (const tmpUser of this.tmpSelectedUsers) {
      try {
        const frameworks = await this.customAPI.FrameworkManagersByManagerId(tmpUser.user?.id);
        if (frameworks.items && frameworks.items.length) {
          await this.splitLastFrameworkUser(frameworks.items, tmpUser);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  /**
   *
   * @param frameworks - All the frameworks user is the manager
   * @param deletingUser - Current deleting user
   */
  async splitLastFrameworkUser(frameworks: any, deletingUser: any): Promise<void> {
    // Because the framework should not have a user other than current user
    for (const framework of frameworks) {
      const filter = {
        managerId: {
          ne: deletingUser.user.id,
        },
        assessmentId: { eq: framework.assessmentId },
      };
      try {
        const result = await this.customAPI.FrameworkManagersByStandardFrameworkId(
          framework.standardFrameworkId,
          null,
          filter
        );
        if (result && result.items && !result.items.length) {
          this.toastrService.error(`${deletingUser.user.name} cannot be deleted as it is the last manager`);
          // If user is the last manager then splice it from selected user.
          this.selectedUsers = this.selectedUsers.filter(selectedUser => {
            if (selectedUser.user && selectedUser.user.id && deletingUser.user && deletingUser.user.id) {
              return selectedUser.user.id !== deletingUser.user.id;
            }
          });
          // if a single framework found which has no other user, then terminate the process (User cannot be deleted)
          return;
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  isUserSelected(): boolean {
    return this.selectedUsers && !!this.selectedUsers.length;
  }
  /**
   * checks for the selected users are vendors
   * if vendors then they should be not the last users.
   */
  checkForVendorUsers(): void {
    if (this.tmpSelectedUsers && this.vendorEntities) {
      // iterate over the selected users to check if they are vendor users.
      this.tmpSelectedUsers.forEach(tmpSelectedUser => {
        // checking and getting the vendor entity
        const selectedVendorEntity =
          this.vendorHash &&
          tmpSelectedUser?.user &&
          tmpSelectedUser?.user?.entityIds &&
          tmpSelectedUser?.user?.entityIds.length
            ? this.vendorHash[tmpSelectedUser?.user?.entityIds[0]]
            : null;
        if (selectedVendorEntity && selectedVendorEntity.userCounter && selectedVendorEntity.userCounter > 1) {
          this.vendorHash[tmpSelectedUser?.user?.entityIds[0]].userCounter--;
        } else if (selectedVendorEntity && selectedVendorEntity.userCounter && selectedVendorEntity.userCounter === 1) {
          const tmpIndex = this.selectedUsers.findIndex(
            selectedUser => selectedUser.user.id === tmpSelectedUser?.user?.id
          );
          if (tmpIndex > -1) {
            this.selectedUsers.splice(tmpIndex, 1);
          }
          this.toastrService.warning(
            `Cannot delete last user: ${tmpSelectedUser?.user?.name} of vendor ${selectedVendorEntity.name}`
          );
        }
      });
    }
  }

  /**
   * this function will delete the users from Database through Auth Service
   * @param users is type of users list
   */
  async deleteUsers(users: any[]) {
    const userIds = users.map(({ user }) => user?.id);
    this.setUsersBusy(userIds, true);
    try {
      this.toastrService.info(`Deleting ${pluralize('user', users.length)}...`);
      await Promise.all(
        // the inner Promise.all must be returned, or the await resolves before the deletes run
        users.map(({ user }) =>
          Promise.all([this.authService.removeUser(user.id), this.authService.deleteUserFromCognito(user)])
        )
      );

      this.toastrService.success(`${pluralize('User', users.length)} deleted!`);
      this.afterDeletedUsers(users);
    } catch (e) {
      const message = UtilsService.msgFromError(e);
      this.toastrService.error(message);
    } finally {
      // on success the rows are already gone; on failure they come back as real rows
      this.setUsersBusy(userIds, false);
    }
  }

  deleteFunction(deletedUsers: any[]): void {
    for (const key in this.users) {
      if (this.users[key]) {
        this.users[key] = this.users[key].filter(
          ({ user }) => !deletedUsers.some(deletedUser => deletedUser.user.id === user.id)
        );
      }
    }
  }
  /**
   * This function modify the
   * @param deletedUsers is type of users list that are deleted
   */
  afterDeletedUsers(deletedUsers: any[]): void {
    // This function will remove the users from all statuses
    this.deleteFunction(deletedUsers);

    this.filteredUserList = this.filteredUserList.filter(
      user => !deletedUsers.some(deletedUser => deletedUser.user.id === user.user.id)
    );
    this.filteredUserList = this.userService.filterUserList(this.filteredUserList);
    this.selectedUsers = [];
  }

  /**
   * Invitation or Enrollment functionality
   */
  async resendEnrollmentPopup(): Promise<void> {
    if (this.selectedUsers && this.selectedUsers.length) {
      try {
        this.toastrService.info('Sending invite...');
        await this.inviteUsers(this.selectedUsers);
        if (this.isInviteSent) {
          this.userSettingService.setIsAllSelected(false);
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      this.toastrService.error('No user selected please select first');
    }
  }

  async inviteUsers(users: any[], isWelcomeEmail: boolean = false) {
    this.isInviteSent = true;
    // every reset/invite path funnels through here, so the targeted rows skeleton from one place
    const userIds = users.map(({ user }) => user?.id);
    this.setUsersBusy(userIds, true);
    try {
      await Promise.all(
        users.map(async ({ user: { id, roleId, email, name, phone } }) => {
          isWelcomeEmail = phone ? true : false; //* flag is true if a phone number already exists
          await this.authService.sendInviteEmail(id, roleId, email, name, isWelcomeEmail);
        })
      );
      this.toastrService.success('Invitation sent successfully');
    } catch (e) {
      const message = UtilsService.msgFromError(e);
      this.isInviteSent = false;
      this.toastrService.error(message);
    } finally {
      this.setUsersBusy(userIds, false);
    }
  }

  /** First page of root entities; `rootEntitiesNextToken` carries the rest. */
  async getExtendEntityList(): Promise<GetEntityQueryExtended[]> {
    this.rootEntitiesNextToken = null;
    if (this.userService.isSuperEntityLeader() && !this.userService.getAssignedRootEntityIds().length) {
      return [];
    }
    return this.fetchRootEntityPage('start');
  }

  /** True while more root entities remain behind the last page fetched. */
  get hasMoreRootEntities(): boolean {
    return !!this.rootEntitiesNextToken;
  }

  /** Next page, triggered by the picker grid's scroll or the entity dropdown's. */
  async loadMoreRootEntities(): Promise<void> {
    if (!this.rootEntitiesNextToken || this.isLoadingMoreRootEntities) {
      return;
    }
    this.isLoadingMoreRootEntities = true;
    try {
      const morePages = await this.fetchRootEntityPage(this.rootEntitiesNextToken);
      if (morePages.length) {
        this.rootEntities = [...this.rootEntities, ...morePages];
      }
    } catch (e) {
      this.logger.error('loadMoreRootEntities - Error: ', e);
    } finally {
      this.isLoadingMoreRootEntities = false;
    }
  }

  /**
   * One page from the same token-based helper Management pages with. Logos are skipped: the picker
   * tile binds the component's own `logoUrl`, not the entity's, so fetching them buys nothing.
   */
  private async fetchRootEntityPage(nextToken: string): Promise<GetEntityQueryExtended[]> {
    const [entities, token] = await this.entityService.listEntityByDomainAlongToken(
      ModelSortDirection.ASC,
      { entityType: { eq: EntityTypeEnum.ROOT_ENTITY }, ...(this.assignedRootEntityFilter() || {}) },
      false,
      nextToken,
      false,
      this.ROOT_ENTITY_PAGE_SIZE
    );
    this.rootEntitiesNextToken = token;
    // The index sorts by entityType, which is identical for every root entity, so sort each page.
    return (entities || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  }

  // Restricts a root entity query to a Super Entity Leader's own entities; null for every other role.
  private assignedRootEntityFilter(): ModelEntityFilterInput {
    if (!this.userService.isSuperEntityLeader()) {
      return null;
    }
    return { or: this.userService.getAssignedRootEntityIds().map(id => ({ id: { eq: id } })) };
  }

  /**
   * on Reset phone
   */
  onResetPhone(): void {}

  async enrollmentConfirm(): Promise<void> {
    try {
      this.toastrService.info('Sending Enrollment invite...');
      await this.inviteUsers(this.selectedUsers, false);
      this.modalRef.close();
    } catch (e) {
      console.log(e);
    }
  }

  private resetSectionLoadingFlags(): void {
    this.isRootEntitiesLoading = true;
    this.isUsersSectionLoading = true;
    this.isKmsSectionLoading = true;
    this.isAiSectionLoading = true;
  }

  private clearSectionLoadingFlags(): void {
    this.isRootEntitiesLoading = false;
    this.isUsersSectionLoading = false;
    this.isKmsSectionLoading = false;
    this.isAiSectionLoading = false;
  }

  /** The picker owns the screen until an entity is chosen; the route decides whether it applies. */
  get showEntityPicker(): boolean {
    return this.entitySelectionMode && !this.hasEntityIdInRoute;
  }

  /** True while a role is being created or updated, which is when the panel hides itself. */
  get isRoleSaveInFlight(): boolean {
    return !!this.pendingRoleName || !!this.pendingRoleId;
  }

  /** SAVE on a new role group: hold a tile in the list and hide the panel while it is created. */
  onRoleSaveStarted(roleName: string): void {
    this.pendingRoleName = roleName;
  }

  /** SAVE on an existing role group: its own tile becomes the placeholder while it is updated. */
  onRoleUpdateStarted(roleId: string): void {
    this.pendingRoleId = roleId;
  }

  /** The save failed, so withdraw the placeholder and bring the panel back for another go. */
  onRoleSaveFailed(): void {
    this.clearPendingRole();
  }

  /** The panel is done with, whether it saved or was cancelled. */
  closeRolePermission(): void {
    this.showRolePermission = false;
    this.clearPendingRole();
  }

  private clearPendingRole(): void {
    this.pendingRoleName = null;
    this.pendingRoleId = null;
  }

  displayRolePermission(): void {
    this.showRolePermission = true;
    this.roleSelected = false;
    this.isDefaultRole = false;
    this.selectedRole = null;
  }

  /**
   * helper method to switch the screens between users and role permissions
   */
  changePermissionHeaderToPermissions(screen: string): void {
    if (screen && screen.toLowerCase() === UsersSettingScreens.users) {
      this.currentTab = UsersSettingScreens.users;
      this.isUsersScreen = true;
    } else if (screen && screen.toLowerCase() === UsersSettingScreens.permissions) {
      this.currentTab = UsersSettingScreens.permissions;
      this.isUsersScreen = false;
    }
  }

  async selectEntityForSettings(entity: GetEntityQuery): Promise<void> {
    this.innerLoading = true;
    this.entity = entity;
    this.entityId = entity.id;
    // const parentEntity = await this.entityService.getEntity(this.entityId, true);
    // const frameworkSettings = JSON.parse(parentEntity.frameworkSettings);
    // this.riskFrameworks = frameworkSettings.RISK_FRAMEWORKS;
    // this.standardList = frameworkSettings.COMPLIANCE_FRAMEWORKS;

    this.entitySelectionMode = false;
    this.activeScan = this.entity.domainScanned ? this.entity.domainScanned : false;
    const domainArr = this.entity.domainScanTimes ? JSON.parse(this.entity.domainScanTimes) : [];
    this.entityDomainValue = domainArr?.length ? domainArr[0].name : '';
    this.ngOnDestroy();
    await this.ngOnInit();
    this.innerLoading = false;
  }

  /**
   * Function to toggle active/inactive button
   */
  async toggleActivation(confirm: boolean = false): Promise<void> {
    if (confirm) {
      await this.enableEncryption();
    }
  }

  async runRotation(): Promise<void> {
    try {
      if (await this.checkIfVendorsCreationInProgress()) {
        this.toastrService.info(
          `Vendors creation for ${this.entity?.name} is in progress please try again in few minutes.`
        );
        return;
      }
      if (!this.entity.KMS) {
        return;
      }

      if (
        this.rotationInProgress ||
        this.entity?.KMS?.rotations?.count >= 3 ||
        this.entity?.KMS?.status !== this.kmsEnum.DONE.toUpperCase()
      ) {
        return;
      }
      this.rotationInProgress = true;

      if (!this.entity.KMS.rotations || (this.entity.KMS.rotations && this.entity.KMS.rotations.count < 3)) {
        this.toastrService.info(`Rotation process started for ${this.entity?.name}...`);

        this.timers = [
          setTimeout(() => {
            this.toastrService.info('This will take few moments, please wait... ');
          }, 2000),
          setInterval(() => {
            this.toastrService.info(
              'Rotation usually takes more time if entity is being used by any user. please wait... '
            );
          }, 16000),
        ];

        let response: any = await this.clientLambdaService.invokeLambda('rotationHandler', {
          action: 'rotate_keys',
          params: {
            rootId: this.entityId,
          },
        });

        if (!response) {
          this.toastrService.error('Error during rotation.');
          this.timers.forEach(timer => clearInterval(timer));
          this.rotationInProgress = false;
          return;
        }

        response = JSON.parse(response.Payload.transformToString());

        if (response.error) {
          this.toastrService.error('Failed: error occurred during rotation process.');
          this.timers.forEach(timer => clearInterval(timer));
          this.rotationInProgress = false;
          return;
        }

        // not 'null' but 'false'
        if (response.response === false) {
          this.toastrService.error('Failed: ' + response.msg);
          this.timers.forEach(timer => clearInterval(timer));
          this.rotationInProgress = false;
          return;
        }
      } else {
        this.toastrService.error('You have reached annual limit of 3 rotations! ');
      }
    } catch (error) {
      console.log('runRotation err - ', error);
      this.toastrService.error(error);
      this.rotationInProgress = false;
    }
  }

  private stopFullPageLoader(): void {
    if (!this.fullPageLoading) {
      return;
    }
    this.fullPageLoading = false;
    this.navigationContext.releaseColdLoad(this.coldLoadKey);
    clearTimeout(this.fullPageLoaderTimer);
  }

  ngOnDestroy() {
    clearTimeout(this.fullPageLoaderTimer);
    clearTimeout(this.searchDebounceTimer);
    clearTimeout(this.filterApplyTimer);
    this.subscriptions.forEach(listener => listener.unsubscribe());
    this.timers?.forEach(timer => clearInterval(timer));
    clearInterval(this.intervalId);
    this.closeModal();
  }

  async enableEncryption(): Promise<void> {
    try {
      if (await this.checkIfVendorsCreationInProgress()) {
        this.toastrService.info(
          `Vendors creation for ${this.entity?.name} is in progress please try again in few minutes.`
        );
        return;
      }
      if (!this.kmsToggle && !this.activationInProgress) {
        this.activationInProgress = true;
        this.toastrService.info(`Encryption process started for ${this.entity?.name}...`);

        this.timers = [
          setTimeout(() => {
            this.toastrService.info('This will take few moments, please wait... ');
          }, 2000),
          setInterval(() => {
            this.toastrService.info('It usually takes more time if entity is being used by any user. please wait... ');
          }, 10000),
        ];

        this.user = await this.userService.getCurrentUser();

        if (!this.user || !this.user.id) {
          this.toastrService.error('Failed to get current user.');
          this.timers.forEach(timer => clearInterval(timer));
          this.activationInProgress = false;
          return;
        }

        await this.clientLambdaService.invokeLambda('securityHandler', {
          action: 'encrypt_root_entity',
          params: {
            rootId: this.entityId,
            userId: this.user.id,
          },
        });
      }
    } catch (err) {
      this.toastrService.error('Failed encryption.', err);
      this.activationInProgress = false;
    }
  }

  async setLatestEntityStatus(): Promise<void> {
    // set lasted KMS status value
    // set latest AI Credits status
    if (this.entityId) {
      this.entity = await this.rootEntityContextService.getRootEntityById(this.entityId);
      this.kmsToggle = this.entity?.KMS?.status === 'DONE';
      delete this.entity?.AI?.__typename;
      this.aiData = this.entity?.AI || { isActive: false };
    }
  }

  async onEncryptionResponse(updatedEntity: any): Promise<void> {
    if (updatedEntity?.entityType === EntityTypeEnum.ROOT_ENTITY) {
      // Make sure the updated entity KMS rotation doesn't exists, to make sure this works for encryption only
      // KMS status is Done Or Failed
      // This block works for showing success or failure of encryption to client
      // Process this block only for the user who has started the encryption process
      const domain = DomainFrameworkService.getDomain();
      if (
        updatedEntity?.domain === domain &&
        !this.isNotFromRotation &&
        !updatedEntity?.KMS?.rotations &&
        updatedEntity?.KMS?.userId === this.user?.id &&
        (updatedEntity?.KMS?.status === this.kmsEnum.DONE.toUpperCase() ||
          updatedEntity?.KMS?.status === this.kmsEnum.FAILED.toUpperCase())
      ) {
        this.timers.forEach(timer => clearInterval(timer));
        if (updatedEntity?.KMS?.status === this.kmsEnum.DONE.toUpperCase()) {
          this.toastrService.success(`${this.entity?.name} is Successfully Encrypted!`);
          this.kmsToggle = true;
        } else {
          this.toastrService.error('Failed: There was an error during encryption process.');
          this.kmsToggle = false;
        }
        this.entity.KMS = updatedEntity.KMS;
        this.activationInProgress = false;
        return;
      }

      // check if the updated entity KMS rotation exists with Done Or Failed status
      // This block works for showing success or failure of rotation to client
      if (
        updatedEntity?.domain === domain &&
        updatedEntity?.KMS?.rotations &&
        !this.isNotFromRotation &&
        (updatedEntity?.KMS?.rotations?.status === this.kmsEnum.DONE.toUpperCase() ||
          updatedEntity?.KMS?.rotations?.status === this.kmsEnum.FAILED.toUpperCase())
      ) {
        this.timers.forEach(timer => clearInterval(timer));
        this.entity = await this.rootEntityContextService.getRootEntityById(this.entityId);
        if (updatedEntity?.KMS?.rotations?.status === this.kmsEnum.DONE.toUpperCase()) {
          this.toastrService.success('Rotation process completed Successfully');
        } else {
          this.toastrService.error('Failed: error occurred during rotation process.');
        }
        this.rotationInProgress = false;
      }
    }
  }

  async fetchVendorsDataStates(entityId: string): Promise<GetDataStateQuery[]> {
    try {
      let token;
      const result: GetDataStateQuery[] = [];
      do {
        const { nextToken, items } = await this.customAPI.DataStatesByParentId(entityId);
        result.push(...items);
        token = nextToken;
      } while (token);

      return result;
    } catch (err) {
      this.toastrService.error('Failed to fetch vendor details.', err);
    }
  }

  async checkIfVendorsCreationInProgress() {
    try {
      const vendors = await this.fetchVendorsDataStates(this.entityId);
      return vendors?.find(vendor => {
        return vendor?.message === 'Vendor in progress';
      });
    } catch (err) {
      this.toastrService.error('Failed to check vendors creation state.', err);
    }
  }

  async updateUserAssignments() {
    try {
      const completiondata = await this.customAPI.getCompletions({ id: this.entityId });
      const readableCompleteionData = await completiondata.body.json();
      // console.log('completiondata,', completiondata?.data?.length, completiondata?.data[0]);
      const completionData1 = readableCompleteionData?.data?.map(item => {
        if (item.userId && item.userId !== SMART_USER) {
          const index = this.allUsers.findIndex(user => user.user.id === item.userId);
          if (index > -1) {
            // console.log('users data', this.allUsers[index]);
            return {
              ...item,
              user: this.allUsers[index].user,
            };
          } else {
            return {
              ...item,
              user: null,
            };
          }
        } else {
          return {
            ...item,
            user: null,
          };
        }
      });

      const usersMap = {};
      // This peace of code is used to filter the Users which are defined and has data
      const completionData = completionData1.flat(1).filter((d: any) => UtilsService.isDefined(d.user));
      const final = {
        data: Object.values(
          completionData.reduce((obj, { user, ...completion }: any) => {
            if (user) {
              usersMap[user.id] = true;
              return {
                ...obj,
                [user.id]: {
                  user: this.getUser(user),
                  access: [AppLevelRoleEnum.ADMIN, AppLevelRoleEnum.MSSP].some(
                    item => item === user.role?.name?.toLowerCase()
                  )
                    ? 'All'
                    : this.entities[completion.subEntityId]?.name,
                  entities: [AppLevelRoleEnum.ADMIN, AppLevelRoleEnum.MSSP].some(
                    item => item === user.role?.name?.toLowerCase()
                  )
                    ? null
                    : [
                        ...(obj && obj[user.id] && obj[user.id].entities ? obj[user.id].entities : []),
                        {
                          ...completion,
                          assignments:
                            completion.assignmentMap && completion.assignmentMap.length ? completion.assignmentMap : [],
                          access: [AppLevelRoleEnum.ADMIN, AppLevelRoleEnum.MSSP].some(
                            item => item === user.role?.name?.toLowerCase()
                          )
                            ? 'All'
                            : this.entities[completion.subEntityId]?.name,
                        },
                      ],
                },
              };
            }
          }, {})
        ),
        map: usersMap,
      };
      return final;
    } catch (err) {
      console.log('err', err);
    }
  }

  updateUsers() {
    if (this.userService.isCustomRole && Object.keys(this.userService.isCustomRole)?.length > 0) {
      [...this.allUsers.filter(item => !this.assignedUsers?.map[item.user.id])]?.map(this.mapUserProgress);
    } else {
      [...this.allUsers.filter(item => !this.assignedUsers?.map[item.user.id]), ...this.assignedUsers.data]?.map(
        this.mapUserProgress
      );
    }
  }

  closeModal() {
    if (this.modalReference != null) {
      this.modalReference.close();
      this.modalReference = null;
      // this.defaultSettingSubMenuClass = 'defaultSettingModalNotActive';
    }
  }

  async activateAttackSurface(): Promise<void> {
    this.activeScan = !this.activeScan;
    const attackSurfacePayload = {
      id: this.entityId,
      domainScanned: this.activeScan,
      domainScanEnabledForEntity: this.activeScan,
      upperdeckSetting: this.activeScan
        ? UPPERDECK_FACELIFT.RESIDUAL_RISK_ATTACK_SURFACE
        : UPPERDECK_FACELIFT.RESIDUAL_RISK,
    };
    await this.customAPI.UpdateEntity(attackSurfacePayload);
    this.rootEntityContextService.addOrUpdateSubEntityInCache(attackSurfacePayload);
  }

  async scanAllDomains(): Promise<void> {
    if (
      this.currentScanType === this.externalScans.INTEGRATION &&
      (!this.bitSightStatus || this.bitSightStatus === 'grey')
    ) {
      this.toastrService.error(
        'Please connect the integration first. Click on its name under the Integrations tab and enter your credentials.'
      );
      return;
    }
    let isValidDomain = true;
    for (const domain of this.domains) {
      isValidDomain = UtilsService.validateDomain(domain.value);
      if (!isValidDomain) {
        isValidDomain = false;
        break;
      }
    }
    if (isValidDomain) {
      this.scanInProgess = true;
      const domainList = this.domains.map(dom => dom.value);
      const isChangeOfService = this.entity.selectedService !== this.currentScanType;
      this.toastrService.info('Scanning your domain in the background. Results will be available shortly!');
      const allFiles = await this.fileService.checkIfPathExistsS3(`EXTERNAL_SCANS/${this.entityId}`);
      const promise = [];
      if (allFiles && allFiles.length) {
        allFiles.forEach(file => {
          if (isChangeOfService) {
            promise.push(this.fileService.deleteFromS3(file, 'path'));
          } else {
            const domName = file.path.split('/')[3];
            const dom = domName.split('.zip')[0];
            const index = domainList.findIndex(d => d === dom);
            if (index === -1) {
              promise.push(this.fileService.deleteFromS3(file, 'path'));
            }
          }
        });
      }
      if (!domainList.length) {
        clearInterval(this.intervalId); // Stop periodic toasters
        this.toastrService.success('Domain scan complete! Your results are now ready to view in the Upperdeck');
        this.scanInProgess = false;
        return;
      }

      // delete all delete s3 file promises
      await Promise.all(promise);
      if (isChangeOfService) {
        this.customAPI.UpdateEntity({
          id: this.entityId,
          domainScanTimes: JSON.stringify(domainList),
          selectedService: this.currentScanType,
        });
      }
      const json = {
        wizardId: this.entityId,
        isRootEntity: true,
        domainList,
        selectedService: this.currentScanType,
      };
      try {
        const res = await this.clientLambdaService.invokeLambda('multiDomainBinaryScan', { ...json });
        this.scanInProgess = false;
        const failedDomains = JSON.parse(res.Payload.transformToString());
        clearInterval(this.intervalId); // Stop periodic toasters when done

        if (
          (domainList?.length >= failedDomains?.length && !(domainList?.length === 1 && failedDomains?.length === 1)) ||
          this.currentScanType === EXTERNAL_SCANS_TYPE.CENTRALEYES
        ) {
          this.toastrService.success(
            'The domain scan has been completed! The results are now available in the Upperdeck.'
          );
        }

        if (this.currentScanType === EXTERNAL_SCANS_TYPE.INTEGRATION) {
          failedDomains?.forEach(failed => {
            let toaster = `The domain ${failed?.domName} is not listed in your BitSight companies and cannot be added automatically. 
            Please add the domain manually in the BitSight portal and try again.`;
            if (failed?.status === 403) {
              toaster = `The domain ${failed?.domName} is not listed in your BitSight companies, 
              and your subscription quota has been reached. 
              Please update your BitSight subscription and try again.`;
            }
            this.toastrService.info(toaster, '', { timeOut: 4000 });
          });
        }
        this.entityDomainValue = this.domainValue;
        this.isEdit = true;
      } catch (error) {
        clearInterval(this.intervalId); // Stop periodic toasters on error
        this.toastrService.error('The domain scan has failed, please try and re-run later.');
        console.log('Issue while scanning domains ' + JSON.stringify(error));
        this.scanInProgess = false;
      }
    } else {
      this.toastrService.error('Please add valid domain');
    }
  }

  openAttackSurfaceModal(header: TemplateRef<any>, content: TemplateRef<any>, footer: TemplateRef<any>) {
    if (this.disableScanning) {
      return;
    }
    const modalRef = this.modalService.open(ModalTemplateComponent, this.ngbModalOptionsAttackSurface);
    const compInstance = modalRef.componentInstance;
    this.modalReference = modalRef;
    compInstance.customizeHeader = true;
    compInstance.headerContentRef = header;
    compInstance.contentRef = content;
    compInstance.footerContentRef = footer;
    this.domainValue = this.domains[0].value;
  }

  domainEdit(isEdit: boolean) {
    if (isEdit) {
      const isValid = UtilsService.validateDomain(this.updatedDomainValue);
      if (isValid) {
        const ifAlreadyExists = this.domains.find(dom => dom.value === this.updatedDomainValue);
        if (ifAlreadyExists) {
          this.toastrService.error('Domain Already Exists in the List');
          return;
        }
        this.domains[0].value = this.updatedDomainValue;
        this.entity.domainScanTimes = JSON.stringify([
          { name: this.updatedDomainValue, created: Date.now(), updated: Date.now() },
        ]);
      } else {
        this.toastrService.error('Please Add Valid Domain');
        return;
      }
    } else {
      const domainArr = this.entity.domainScanTimes ? JSON.parse(this.entity.domainScanTimes) : [];
      this.domains[0].value = domainArr?.length ? domainArr[0].name : '';
    }
    this.updatedDomainValue = '';
    this.closeModal();
  }

  openExternalScanRequestModal(header: TemplateRef<any>, content: TemplateRef<any>, footer: TemplateRef<any>) {
    const modalRef = this.modalService.open(ModalTemplateComponent, this.ngbModalOptionsExternalScanRequest);
    const compInstance = modalRef.componentInstance;
    this.closeModalInstance = modalRef;
    compInstance.customizeHeader = true;
    compInstance.headerContentRef = header;
    compInstance.contentRef = content;
    compInstance.footerContentRef = footer;
  }
  openExternalScanRequestScanAcknowledgementModal(
    header: TemplateRef<any>,
    content: TemplateRef<any>,
    footer: TemplateRef<any>
  ) {
    this.closeModal();
    const modalRef = this.modalService.open(
      ModalTemplateComponent,
      this.ngbModalOptionsExternalScanRequestScanAcknowledgement
    );
    const compInstance = modalRef.componentInstance;
    this.closeModalInstance = modalRef;
    compInstance.customizeHeader = true;
    compInstance.headerContentRef = header;
    compInstance.contentRef = content;
    compInstance.footerContentRef = footer;
    const emailObject = {
      type: 'NOTIFY_CENTRALEYES_EXTERNAL_SCAN_REQUEST',
      userName: this.currentUser.name,
      userEmail: this.currentUser.email,
      entityName: this.entity.name,
      domain: DomainFrameworkService.getDomain(),
    };
    this.senEmailContent(emailObject);
  }
  async senEmailContent(emailContent) {
    await this.clientLambdaService.invokeLambda('sendNotification', emailContent);
  }

  openNewFrameworkRequestModal() {
    const modalRef = this.modalService.open(NewFrameworkRequestModalComponent, this.ngbModalOptionsNewFrameworkRequest);
    modalRef.componentInstance.userName = this.currentUser.name;
    modalRef.componentInstance.userEmail = this.currentUser.email;
    modalRef.componentInstance.riskFrameworks = this.riskFrameworks.filter(risk => risk.status === false);
    modalRef.componentInstance.complianceFrameworks = this.standardList.filter(
      compliance => compliance.status === false
    );
    this.closeModalInstance = modalRef;
  }

  updateDomains(index: number, value: string): void {
    this.domains[index].value = value;
  }

  deleteDomains(idx: number): void {
    this.domains.splice(idx, 1);
  }

  isValidDomains(): boolean {
    return this.domains.every(dom => dom.value !== '');
  }

  switchTabs(activeTab): void {
    const currentDomains = JSON.parse(JSON.stringify(this.domains));
    this.domains = JSON.parse(JSON.stringify(this.cachedDomains));
    this.cachedDomains = currentDomains;
    this.currentScanType = activeTab;
  }

  addDomain(): void {
    this.domains.push({ value: '', isFromDb: false });
  }

  async openDomainModal(header, content, footer): Promise<void> {
    if (this.bitSightStatus) {
      this.loading = true;
      const payload = {
        id: this.entityId,
        service: 'bitsight',
        type: 'Query',
        source: 'frontend',
      };
      const integration = await this.customAPI.HandleIntegrationDetails(JSON.stringify(payload));
      this.loading = false;
      const integrationReadable = await integration.body.json();
      if (integrationReadable) {
        const integrationData = integrationReadable;

        const credentials = JSON.parse(integrationData.credentials);
        if (credentials?.token) {
          this.bitsightToken = credentials.token;
        }

        if (!this.entity?.integrations?.length) {
          this.entity = await this.rootEntityContextService.getRootEntityById(this.entityId);
        }

        if (this.entity?.integrations?.length) {
          const idx = this.entity.integrations.findIndex(int => int.name === integrationData.name);
          if (idx >= 0) {
            this.entity.integrations[idx].credentials = integrationData.credentials;
          }
        } else {
          this.entity.integrations = [integrationData];
        }
      }
    }
    const modalRef = this.modalService.open(ModalTemplateComponent, this.ngbModalOptionsExternalScans);
    const compInstance = modalRef.componentInstance;
    this.modalReference = modalRef;
    compInstance.customizeHeader = true;
    compInstance.headerContentRef = header;
    compInstance.contentRef = content;
    compInstance.footerContentRef = footer;
    this.closeModalInstance = modalRef;
  }

  connectBitsight(): void {
    if (!this.bitsightToken || this.bitSightStatus === '') {
      return;
    }
    this.loading = true;
    this.closeModal();
    const payload = {
      url: this.bitsightUrl,
      token: this.bitsightToken,
      entityId: this.entityId,
    };
    from(this.customAPI.connectBitsight(payload)).subscribe(
      (res: any) => {
        this.loading = false;
        if (res?.statusCode === 200) {
          this.bitSightStatus = 'green';
          this.toastrService.success('Successfully Created Bitsight Connection');
        }
      },
      err => {
        this.loading = false;
        this.bitSightStatus = 'grey';
        this.toastrService.error('Failed to create Bitsight Connection');
      }
    );
  }

  // Risk Register -> Dynamic Field Functions.
  /** Opens the authoring panel in create mode (Figma node 117:9950). */
  addRiskRegisterDynamicField(): void {
    this.selectedRiskRegisterDynamicField = null;
    this.isRiskDynamicFieldPanelOpen = true;
    this.riskDynamicFieldUsageCount = 0;
  }

  /** Opens the authoring panel on an existing definition (Figma node 117:10751). */
  async openRiskRegisterDynamicField(field: RiskDynamicField): Promise<void> {
    this.selectedRiskRegisterDynamicField = field;
    this.isRiskDynamicFieldPanelOpen = true;
    this.riskDynamicFieldUsageCount = await this.riskDynamicFieldService.getUsageCount(field?.key, this.entityId);
  }

  closeRiskDynamicFieldPanel(): void {
    this.isRiskDynamicFieldPanelOpen = false;
    this.selectedRiskRegisterDynamicField = null;
  }

  /**
   * `showSectionLoading` is false when a single card is already showing a placeholder for its own
   * mutation - the section must not collapse to skeletons and hide it.
   */
  async getRiskDynamicFields(showSectionLoading: boolean = true): Promise<void> {
    if (!this.entityId) {
      return;
    }
    this.isRiskDynamicFieldLoading = showSectionLoading;
    try {
      this.riskRegisterDynamicFields = await this.riskDynamicFieldService.getActiveFields(this.entityId, true);
    } catch (e) {
      this.logger.error(e);
      this.toastrService.error('Failed to load dynamic fields');
    }
    this.isRiskDynamicFieldLoading = false;
  }

  async saveRiskDynamicField(definition: RiskDynamicField): Promise<void> {
    if (this.isRiskDynamicFieldSaving) {
      return;
    }
    this.isRiskDynamicFieldSaving = true;
    const isUpdate = !!this.selectedRiskRegisterDynamicField?.key;
    // hold a placeholder where the saved field will land, before the panel clears the selection
    if (isUpdate) {
      this.pendingDynamicFieldKey = this.selectedRiskRegisterDynamicField.key;
    } else {
      this.isCreatingDynamicField = true;
    }
    try {
      if (isUpdate) {
        const existing = this.selectedRiskRegisterDynamicField;
        await this.riskDynamicFieldService.updateField({ ...definition, order: existing.order }, this.entityId);

        if (existing.type !== definition.type) {
          this.riskDynamicFieldService.clearValues(definition.key, this.entityId);
        }
      } else {
        const order = this.riskRegisterDynamicFields.length;
        await this.riskDynamicFieldService.createField({ ...definition, order }, this.entityId);
      }
      this.toastrService.success(`Dynamic field ${isUpdate ? 'updated' : 'created'} successfully`);
      this.closeRiskDynamicFieldPanel();
      await this.getRiskDynamicFields(false);
    } catch (e) {
      this.logger.error(e);
      this.toastrService.error(`Failed to ${isUpdate ? 'update' : 'create'} dynamic field`);
    } finally {
      this.isRiskDynamicFieldSaving = false;
      this.clearPendingDynamicField();
    }
  }

  private clearPendingDynamicField(): void {
    this.pendingDynamicFieldKey = null;
    this.isCreatingDynamicField = false;
  }

  toggleRiskDynamicFieldEditMode(): void {
    this.riskDynamicFieldEditMode = !this.riskDynamicFieldEditMode;
  }

  confirmDeleteRiskDynamicField(definition: RiskDynamicField): void {
    if (!definition || this.isRiskDynamicFieldSaving) {
      return;
    }
    this.riskDynamicFieldPendingDelete = definition;
  }

  closeRiskDynamicFieldDeleteModal(): void {
    this.riskDynamicFieldPendingDelete = null;
  }

  async deleteRiskDynamicField(mode: RiskDynamicFieldDeleteMode): Promise<void> {
    const definition = this.riskDynamicFieldPendingDelete;
    if (!definition || this.isRiskDynamicFieldSaving) {
      return;
    }
    this.isRiskDynamicFieldSaving = true;
    // the card stands as a skeleton until the delete comes back, then leaves with the refresh
    this.pendingDynamicFieldKey = definition.key;
    try {
      await this.riskDynamicFieldService.deleteField(definition, this.entityId, mode);
      this.toastrService.success(
        mode === RiskDynamicFieldDeleteMode.ALL_RISKS
          ? 'Dynamic field and its values deleted successfully'
          : 'Dynamic field removed from new risks'
      );
      this.closeRiskDynamicFieldDeleteModal();
      if (this.selectedRiskRegisterDynamicField?.key === definition.key) {
        this.closeRiskDynamicFieldPanel();
      }
      await this.getRiskDynamicFields(false);
    } catch (e) {
      this.logger.error(e);
      this.toastrService.error('Failed to delete dynamic field');
    } finally {
      this.isRiskDynamicFieldSaving = false;
      this.clearPendingDynamicField();
    }
  }

  trackRiskDynamicFieldByKey(index: number, field: RiskDynamicField): string {
    return field.key;
  }

  // Dynamic Label Manager Functions.
  toggleDynamicLabelManagerSection(section: DynamicLabelManagerSections): void {
    this.isDynamicLabelManagerLoading = true;
    this.dynamicLabelManagerSections.forEach(s =>
      s.name === section ? (s.isSelected = !s.isSelected) : (s.isSelected = false)
    );
    this.searchFormObject = {
      tagSearchText: '',
      categorySearchText: '',
    };
    this.isAddEnabled = false;
    this.currentSelectedSection = null;
    this.selectedDynamicLabelManagerItems = {
      tags: [],
      categories: [],
    };
    this.newTagValue = '';

    this.populateDynamicLabelManagerSections(section);
  }

  addOrRemoveTagOrCategoryFromSelectedItems(item: any, type: 'tags' | 'categories'): void {
    if (item.selected) {
      this.selectedDynamicLabelManagerItems[type].push(item);
    } else {
      const index = this.selectedDynamicLabelManagerItems[type].findIndex(i => i.id === item.id);
      if (index >= 0) {
        this.selectedDynamicLabelManagerItems[type].splice(index, 1);
      }
    }
  }

  selectDynamicLabelManagerItem(item: any, title: DynamicLabelManagerSections): void {
    item.selected = !item.selected;
    const isTagSection = this.isTagSection(title);
    this.addOrRemoveTagOrCategoryFromSelectedItems(item, isTagSection ? 'tags' : 'categories');
  }

  /**
   * Whether every selectable item in the given list is currently selected.
   * For Policy Categories this checks every sub-value across every group.
   */
  isAllDynamicLabelsSelected(items: any[], title: DynamicLabelManagerSections): boolean {
    if (!items?.length) {
      return false;
    }
    if (title === DynamicLabelManagerSections.POLICY_CATEGORIES) {
      const allValues = items.reduce((acc: any[], group: any) => acc.concat(group?.values || []), []);
      return allValues.length > 0 && allValues.every((v: any) => v.selected);
    }
    return items.every((i: any) => i.selected);
  }

  /**
   * Toggle the "All" checkbox at the top of a Dynamic Label Manager list.
   * Selecting flips every item to selected and pushes them into selectedDynamicLabelManagerItems;
   * deselecting clears them.
   */
  toggleAllDynamicLabelManagerItems(items: any[], title: DynamicLabelManagerSections): void {
    if (!items?.length) {
      return;
    }
    const isTag = this.isTagSection(title);
    const targetKey: 'tags' | 'categories' = isTag ? 'tags' : 'categories';
    const shouldSelect = !this.isAllDynamicLabelsSelected(items, title);

    if (title === DynamicLabelManagerSections.POLICY_CATEGORIES) {
      const allValues: any[] = [];
      items.forEach((group: any) => {
        (group?.values || []).forEach((v: any) => {
          v.selected = shouldSelect;
          allValues.push(v);
        });
      });
      this.selectedDynamicLabelManagerItems.categories = shouldSelect ? [...allValues] : [];
    } else {
      items.forEach((i: any) => {
        i.selected = shouldSelect;
      });
      this.selectedDynamicLabelManagerItems[targetKey] = shouldSelect ? [...items] : [];
    }
  }

  createDynamicLabelManagerObject(
    section: DynamicLabelManagerSections,
    tagsTitle: DynamicLabelManagerSections,
    categoriesTitle: DynamicLabelManagerSections,
    type: LabelType
  ): any {
    return {
      title: section,
      tagsTitle,
      categoriesTitle,
      type,
      tags: [],
      categories: [],
    };
  }

  fetchingDynamicLabelManagerData(entityId: string): void {
    forkJoin([
      this.getTagsByEntityId(entityId, this.dynamicLabelManagerMapper.type),
      this.getCategoriesByEntityId(entityId, this.dynamicLabelManagerMapper.type),
    ]).subscribe(([tags, categories]) => {
      this.dynamicLabelManagerMapper.tags = tags.map(tag => ({
        id: tag.id,
        name: tag.name,
        selected: false,
        type: 'tag',
      }));

      if (this.dynamicLabelManagerMapper.type === LabelType.POLICY) {
        const categoriesMapper = {};
        // Creating a mapper with the name;
        categories.forEach(category => {
          if (!category.categoryId && category.id && !categoriesMapper[category.id]) {
            categoriesMapper[category.id] = {
              values: [],
              name: category.name,
              id: category.id,
              color: this.getCategoryColor(category.name),
              isDefault: this.isDefaultCategory(category.name),
              type: 'category',
            };
          }
        });
        // Populating the mapper with the subCategories values.
        categories.forEach(category => {
          if (category.categoryId && categoriesMapper[category.categoryId]) {
            categoriesMapper[category.categoryId].values.push(category);
          }
        });

        Object.keys(categoriesMapper).forEach(categoryName => {
          this.dynamicLabelManagerMapper.categories.push({
            name: categoriesMapper[categoryName].name,
            id: categoriesMapper[categoryName].id,
            color: categoriesMapper[categoryName].color,
            isDefault: categoriesMapper[categoryName].isDefault,
            values: categoriesMapper[categoryName].values.map(subValue => ({
              id: subValue.id,
              name: subValue.name,
              selected: false,
              type: 'category',
            })),
          });
        });
      } else {
        this.dynamicLabelManagerMapper.categories = categories.map(category => ({
          id: category.id,
          name: category.name,
          selected: false,
          type: 'category',
        }));
      }
      this.filteredDynamicLabelManagerItems = { ...JSON.parse(JSON.stringify(this.dynamicLabelManagerMapper)) };
      this.isDynamicLabelManagerLoading = false;
    });
  }

  populateDynamicLabelManagerSections(value: string): void {
    if (!this.entityId) {
      this.entityId = UtilsService.getRouteParam(this.route.root.snapshot, 'entityId');
    }
    this.selectedDynamicLabelManagerItems = {
      tags: [],
      categories: [],
    };

    // 1- Creating the Dynamic Label Manager Mapper Object.
    switch (value) {
      case DynamicLabelManagerSections.GENERAL_TAGS: {
        this.dynamicLabelManagerMapper = this.createDynamicLabelManagerObject(
          DynamicLabelManagerSections.GENERAL_TAGS,
          DynamicLabelManagerSections.GENERAL_TAGS,
          DynamicLabelManagerSections.GENERAL_CATEGORIES,
          LabelType.GENERAL
        );
        break;
      }
      case DynamicLabelManagerSections.RISK_REGISTER: {
        this.dynamicLabelManagerMapper = this.createDynamicLabelManagerObject(
          DynamicLabelManagerSections.RISK_REGISTER,
          DynamicLabelManagerSections.RISK_TAGS,
          DynamicLabelManagerSections.RISK_CATEGORIES,
          LabelType.RISK
        );
        break;
      }
      case DynamicLabelManagerSections.POLICY_MANAGEMENT: {
        this.dynamicLabelManagerMapper = this.createDynamicLabelManagerObject(
          DynamicLabelManagerSections.POLICY_MANAGEMENT,
          DynamicLabelManagerSections.POLICY_TAGS,
          DynamicLabelManagerSections.POLICY_CATEGORIES,
          LabelType.POLICY
        );
        break;
      }
      case DynamicLabelManagerSections.REMEDIATION: {
        this.dynamicLabelManagerMapper = this.createDynamicLabelManagerObject(
          DynamicLabelManagerSections.REMEDIATION,
          DynamicLabelManagerSections.REMEDIATION_TAGS,
          DynamicLabelManagerSections.REMEDIATION_CATEGORIES,
          LabelType.REMEDIATION
        );
        break;
      }
    }

    // 2- Fetching the data related to the Dynamic Label Manager Mapper Object.
    this.fetchingDynamicLabelManagerData(this.entityId);
  }

  showAddBoxForTagOrCategory(title: string, subCategoryId?: string): void {
    this.currentSelectedSection = subCategoryId ? subCategoryId : title;
    this.isAddEnabled = true;
  }

  // Helper functions for Adding the new tag or Category,
  isTagSection(title: DynamicLabelManagerSections): boolean {
    return [
      DynamicLabelManagerSections.GENERAL_TAGS,
      DynamicLabelManagerSections.RISK_TAGS,
      DynamicLabelManagerSections.POLICY_TAGS,
    ].includes(title);
  }

  handleTagAddition(type: LabelType, isBulkUpload?: boolean): void {
    const newId = uuid();
    const tagExists = this.dynamicLabelManagerMapper.tags.find(tag => tag.name === this.newTagValue);
    if (tagExists) {
      this.toastrService.error('Tag already exists');
      return;
    }
    this.dynamicLabelManagerMapper.tags.push({
      id: newId,
      name: this.newTagValue,
      selected: false,
      type: 'tag',
    });

    const payload: any = {
      id: newId,
      name: this.newTagValue,
      entityId: this.entityId,
      domain: this.entity.domain,
      targetId: '_Global',
      targetName: '_Global',
      assessmentFrameworkKey: '_Global',
      referenceId: '_Global',
      questionRefId: '_Global',
      type,
      parentTagId: null,
    };

    if (!isBulkUpload) {
      this.rootEntityContextService.createTag(payload);
    } else {
      this.bulkUploadPromise.push(this.rootEntityContextService.createTag(payload));
    }
    this.filteredDynamicLabelManagerItems.tags = JSON.parse(JSON.stringify(this.dynamicLabelManagerMapper.tags));
  }

  handleCategoryAddition(
    type: LabelType,
    isBulkUpload?: boolean,
    title?: DynamicLabelManagerSections,
    subCategoryName?: string
  ): void {
    let categoryId = null;
    const newId = uuid();

    switch (title) {
      case DynamicLabelManagerSections.POLICY_CATEGORIES: {
        if (subCategoryName) {
          const categoryIndex = this.dynamicLabelManagerMapper.categories.findIndex(
            value => value.name === subCategoryName
          );
          if (categoryIndex < 0) {
            return;
          }
          categoryId = this.dynamicLabelManagerMapper.categories[categoryIndex].id;
          // check if the sub category already exists.
          const subCategoryExists = this.dynamicLabelManagerMapper.categories[categoryIndex]?.values.find(
            value => value.name === this.newTagValue
          );
          if (subCategoryExists) {
            this.toastrService.error('Sub Category already exists');
            return;
          }
          this.dynamicLabelManagerMapper.categories[categoryIndex]?.values.push({
            id: newId,
            name: this.newTagValue,
            selected: false,
            isDefault: false,
            type: 'category',
          });
        } else {
          // check if the category already exists.
          const categoryExists = this.dynamicLabelManagerMapper.categories.find(
            category => category.name === this.newTagValue
          );
          if (categoryExists) {
            this.toastrService.error('Parent Category already exists');
            return;
          }
          this.dynamicLabelManagerMapper.categories.unshift({
            id: newId,
            name: this.newTagValue,
            isDefault: false,
            color: this.getCategoryColor(this.newTagValue),
            values: [],
            type: 'category',
          });
        }
        break;
      }
      default: {
        const categoryExists = this.dynamicLabelManagerMapper.categories.find(
          category => category.name === this.newTagValue
        );
        if (categoryExists) {
          this.toastrService.error('Category already exists');
          return;
        }
        this.dynamicLabelManagerMapper.categories.push({
          id: newId,
          name: this.newTagValue,
          selected: false,
        });
        break;
      }
    }
    const payload = {
      id: newId,
      type,
      targetId: '_Global',
      name: this.newTagValue,
      entityId: this.entityId,
      categoryName: subCategoryName || null,
      categoryId,
      targetName: '_Global',
    };
    if (!isBulkUpload) {
      this.rootEntityContextService.createCategory(payload);
    } else {
      this.bulkUploadPromise.push(this.rootEntityContextService.createCategory(payload));
    }
    this.filteredDynamicLabelManagerItems.categories = JSON.parse(
      JSON.stringify(this.dynamicLabelManagerMapper.categories)
    );
  }

  addNewTagOrCategory(
    title: DynamicLabelManagerSections,
    subCategoryName?: string,
    type?: LabelType,
    isBulkUpload?: boolean
  ): void {
    // Checking the validations.
    if (this.newTagValue.trim() === '') {
      this.toastrService.error('Field cannot be empty');
      return;
    }
    if (this.newTagValue.length > 30) {
      this.toastrService.error('Field cannot be more than 30 characters');
      return;
    }

    const isTag = this.isTagSection(title);
    if (isTag) {
      this.handleTagAddition(type, isBulkUpload);
    } else {
      this.handleCategoryAddition(type, isBulkUpload, title, subCategoryName);
    }
    this.currentSelectedSection = null;
    this.isAddEnabled = false;
    this.newTagValue = '';
    this.searchFormObject = {
      tagSearchText: '',
      categorySearchText: '',
    };
  }

  async deleteDynamicLabelManagerItem(): Promise<void> {
    if (
      this.selectedDynamicLabelManagerItems.tags?.length > 0 ||
      this.selectedDynamicLabelManagerItems.categories?.length > 0
    ) {
      // first we need to fetch related tags and categories.
      this.toastrService.info('Fetching related tags and categories...Please wait...');
      const relatedTagsAndCategories = await this.getRelatedTagsAndCategories();

      // Need to open the modal to confirm the deletion.
      const modalRef = this.modalService.open(DeleteModalComponent, this.ngbModalDeleteDynamicLabelOptions);
      modalRef.componentInstance.titleText = 'DYNAMIC LABEL REMOVAL';

      const artifactNames = [];
      const targetValues = [];
      let artifactsCount = 0;
      Object.keys(relatedTagsAndCategories.tagsMapper).forEach(key => {
        artifactNames.push(relatedTagsAndCategories.tagsMapper[key].name);
        artifactsCount++;
        relatedTagsAndCategories.tagsMapper[key]?.values?.forEach(value => {
          targetValues.push({
            name: value?.targetName,
            id: value?.id,
            type: 'tag',
          });
        });
      });
      Object.keys(relatedTagsAndCategories.categoriesMapper).forEach(key => {
        artifactNames.push(relatedTagsAndCategories.categoriesMapper[key].name);
        artifactsCount++;
        relatedTagsAndCategories.categoriesMapper[key]?.values?.forEach(value => {
          targetValues.push({ name: value?.name, id: value?.id, type: 'category' });
        });
      });
      modalRef.componentInstance.artifactsNames = artifactNames;
      modalRef.componentInstance.artifactsCount = artifactsCount;
      modalRef.componentInstance.svgName = '';
      modalRef.componentInstance.modalType =
        targetValues.length > 0
          ? DeleteModalTypeEnum.DELETE_DYNAMIC_LABEL_CHECK
          : DeleteModalTypeEnum.DELETE_DYNAMIC_LABEL;
      modalRef.componentInstance.selectedQuestions = targetValues;

      modalRef.componentInstance.deleteFramework.subscribe((event: boolean) => {
        if (event) {
          this.isDynamicLabelManagerLoading = true;
          if (targetValues.length) {
            this.deleteDynamicLabelRelatedItems(targetValues);
          }
          if (
            this.selectedDynamicLabelManagerItems.tags?.length ||
            this.selectedDynamicLabelManagerItems.categories?.length
          ) {
            this.deleteDynamicLabelRelatedItems(this.selectedDynamicLabelManagerItems.tags);
            this.deleteDynamicLabelRelatedItems(this.selectedDynamicLabelManagerItems.categories);

            // Need to remove the local data too. Because we are deleting the items from the local data.
            this.updateDynamicLabelManagerItemsAfterDelete();
          }

          // If we have type of general, we need to run the lambda in order to see if after deleting the tag,
          // is there any group which is not empty. We need to remove those groups too.
          if (this.dynamicLabelManagerMapper.type === LabelType.GENERAL) {
            this.deleteDynamicLabelRelatedGroups(this.selectedDynamicLabelManagerItems.tags);
          }

          // Reset selection so a subsequent delete doesn't include already-deleted items
          this.selectedDynamicLabelManagerItems = { tags: [], categories: [] };

          this.isDynamicLabelManagerLoading = false;
        }
      });
    } else {
      this.toastrService.error('Please select at least one item to delete');
    }
  }

  deleteDynamicLabelRelatedGroups(tags: any[]): void {
    try {
      const lambdaPayload = {
        entityId: this.entityId,
        labelType: this.dynamicLabelManagerMapper.type,
        tags: [],
        categories: [],
        type: 'DELETE',
      };
      tags.forEach(tag => {
        lambdaPayload.tags.push(tag.id);
      });
      // Need to invoke the lambda to delete the related groups.
      this.clientLambdaService.invokeLambda('dynamicLabelHandler', lambdaPayload);
      this.rootEntityContextService.invalidateGroupsCache();
    } catch (error) {
      console.log('cannot delete the dynamic label related groups error - ', error);
    }
  }

  updateDynamicLabelManagerItemsAfterDelete(): void {
    if (this.selectedDynamicLabelManagerItems.tags?.length) {
      this.selectedDynamicLabelManagerItems.tags.forEach(tag => {
        // Find in the dynamicLabelManagerMapper.tags and remove the tag.
        const index = this.dynamicLabelManagerMapper.tags.findIndex(t => t.id === tag.id);
        if (index >= 0) {
          this.dynamicLabelManagerMapper.tags.splice(index, 1);
        }
      });

      this.filteredDynamicLabelManagerItems.tags = JSON.parse(JSON.stringify(this.dynamicLabelManagerMapper.tags));
    }
    if (this.selectedDynamicLabelManagerItems.categories?.length) {
      this.selectedDynamicLabelManagerItems.categories.forEach(category => {
        // Find in the dynamicLabelManagerMapper.categories and remove the category.
        if (this.dynamicLabelManagerMapper.type === LabelType.POLICY) {
          this.dynamicLabelManagerMapper.categories.forEach(c => {
            const index = c.values.findIndex(v => v.id === category.id);
            if (index >= 0) {
              c.values.splice(index, 1);
            }
          });
        } else {
          const index = this.dynamicLabelManagerMapper.categories.findIndex(c => c.id === category.id);
          if (index >= 0) {
            this.dynamicLabelManagerMapper.categories.splice(index, 1);
          }
        }
        this.filteredDynamicLabelManagerItems.categories = JSON.parse(
          JSON.stringify(this.dynamicLabelManagerMapper.categories)
        );
      });
    }
  }

  async deleteDynamicLabelRelatedItems(targetValues: any): Promise<void> {
    try {
      const deleteTagsPromises = [];
      const deleteCategoriesPromises = [];

      if (targetValues.length) {
        targetValues.forEach(value => {
          if (value.type === 'tag') {
            deleteTagsPromises.push(this.rootEntityContextService.deleteTag(value.id, this.entityId));
          } else {
            deleteCategoriesPromises.push(this.rootEntityContextService.deleteCategory(value.id, this.entityId));
          }
        });
      }
      await Promise.all([...deleteTagsPromises, ...deleteCategoriesPromises]);
      this.toastrService.success('Dynamic label related items deleted successfully');
    } catch (error) {
      console.log('cannot delete the dynamic label related items error - ', error);
    }
  }

  async getRelatedTagsAndCategories(): Promise<any> {
    try {
      const tagsMapper = {};
      const categoriesMapper = {};

      if (this.selectedDynamicLabelManagerItems.tags?.length) {
        await Promise.all(
          this.selectedDynamicLabelManagerItems.tags.map(async tag => {
            tagsMapper[tag.id] = {
              name: tag.name,
              values: [],
            };
            const relatedTags = await this.rootEntityContextService.getTagsByParentTagId(tag.id);
            tagsMapper[tag.id].values = relatedTags || [];
          })
        );
      }

      if (this.selectedDynamicLabelManagerItems.categories?.length) {
        await Promise.all(
          this.selectedDynamicLabelManagerItems.categories.map(async category => {
            categoriesMapper[category.id] = {
              name: category.name,
              values: [],
            };
            const relatedCategories = await this.rootEntityContextService.getCategoriesByCategoryId(category.id);
            categoriesMapper[category.id].values = (relatedCategories || []).map(cat => ({
              id: cat.id,
              name: cat.targetName,
            }));
          })
        );
      }
      return { tagsMapper, categoriesMapper };
    } catch (error) {
      console.log('cannot check the validity of the selected items error - ', error);
      return false;
    }

    return false;
    return true;
  }

  // Fetching the data from dynamoDB for getting the tags.
  async getTagsByEntityId(entityId: string, type?: LabelType): Promise<any> {
    try {
      return await this.rootEntityContextService.getTagsByEntityId(entityId, type, '_Global');
    } catch (error) {
      console.log('cannot get the tags error - ', error);
      return [];
    }
  }

  // Fetching the data from dynamoDB for getting the categories.
  async getCategoriesByEntityId(entityId: string, type?: LabelType): Promise<any> {
    try {
      return await this.rootEntityContextService.getCategoriesByEntityId(entityId, type, '_Global');
    } catch (error) {
      console.log('cannot get the categories error - ', error);
      return [];
    }
  }

  closeAddBoxForTagOrCategory(title: string): void {
    this.currentSelectedSection = null;
    this.isAddEnabled = false;
    this.newTagValue = '';
  }

  searchDynamicLabelManagerItems(term: any, title: string, type: LabelType): void {
    if (term) {
      if (title === DynamicLabelManagerSections.POLICY_CATEGORIES) {
        this.filteredDynamicLabelManagerItems.categories = this.dynamicLabelManagerMapper.categories.filter(
          category => {
            return category.values.some(value => value.name.toLowerCase().includes(term.toLowerCase()));
          }
        );
      } else if (
        title === DynamicLabelManagerSections.RISK_CATEGORIES ||
        title === DynamicLabelManagerSections.GENERAL_CATEGORIES
      ) {
        this.filteredDynamicLabelManagerItems.categories = this.dynamicLabelManagerMapper.categories.filter(category =>
          category.name.toLowerCase().includes(term.toLowerCase())
        );
      } else {
        this.filteredDynamicLabelManagerItems.tags = this.dynamicLabelManagerMapper.tags.filter(tag =>
          tag.name.toLowerCase().includes(term.toLowerCase())
        );
      }
    } else {
      this.filteredDynamicLabelManagerItems = { ...JSON.parse(JSON.stringify(this.dynamicLabelManagerMapper)) };
    }
  }

  async updateDynamicLabelManagerItems(): Promise<void> {
    try {
      const updatedTagsPromises = [];
      const updatedCategoriesPromises = [];
      const lambdaPayload = {
        entityId: this.entityId,
        labelType: this.dynamicLabelManagerMapper.type,
        tags: [],
        categories: [],
        type: 'UPDATE',
      };
      // 1- First we need to need to check which elements are updated from both tags and categories list.
      // 2- For checking the difference we will compare filteredDynamicLabelManagerItems with dynamicLabelManagerMapper.
      this.filteredDynamicLabelManagerItems.tags.forEach(tag => {
        const dynamicLabelManagerTag = this.dynamicLabelManagerMapper.tags.find(
          t => t.id === tag.id && t.name !== tag.name
        );
        if (dynamicLabelManagerTag) {
          lambdaPayload.tags.push(dynamicLabelManagerTag.id);
          updatedTagsPromises.push(
            this.rootEntityContextService.updateTag(dynamicLabelManagerTag.id, tag.name, this.entityId)
          );
        }
      });

      if (this.dynamicLabelManagerMapper.type === LabelType.POLICY) {
        this.filteredDynamicLabelManagerItems.categories.forEach(category => {
          // First we will get the category from the dynamicLabelManagerMapper.
          // then we will compare the values of both objects.
          const dynamicLabelManagerCategory = this.dynamicLabelManagerMapper.categories.find(c => c.id === category.id);
          if (dynamicLabelManagerCategory) {
            dynamicLabelManagerCategory.values.forEach(value => {
              const dynamicLabelManagerValue = category.values.find(v => v.id === value.id && v.name !== value.name);
              if (dynamicLabelManagerValue) {
                lambdaPayload.categories.push(dynamicLabelManagerValue.id);
                updatedCategoriesPromises.push(
                  this.rootEntityContextService.updateCategory(
                    dynamicLabelManagerValue.id,
                    category.name,
                    this.entityId
                  )
                );
              }
            });

            if (dynamicLabelManagerCategory.name !== category.name) {
              updatedCategoriesPromises.push(
                this.rootEntityContextService.updateCategory(
                  dynamicLabelManagerCategory.id,
                  category.name,
                  this.entityId
                )
              );
            }
          }
        });
      } else {
        this.filteredDynamicLabelManagerItems.categories.forEach(category => {
          const dynamicLabelManagerCategory = this.dynamicLabelManagerMapper.categories.find(c => c.id === category.id);
          if (dynamicLabelManagerCategory) {
            if (dynamicLabelManagerCategory.name !== category.name) {
              lambdaPayload.categories.push(dynamicLabelManagerCategory.id);
              updatedCategoriesPromises.push(
                this.rootEntityContextService.updateCategory(
                  dynamicLabelManagerCategory.id,
                  category.name,
                  this.entityId
                )
              );
            }
          }
        });
      }

      // Need to invoke the lambda here too to update the tags/categories at target places.
      // Write helper function to updateTagsPromises and updatedCategoriesPromises batch by batch of 10.
      await this.updateTagsAndCategoriesBatch(updatedTagsPromises, updatedCategoriesPromises);
      // await Promise.all([...updatedTagsPromises, ...updatedCategoriesPromises]);
      if (lambdaPayload.tags.length > 0 || lambdaPayload.categories.length > 0) {
        this.clientLambdaService.invokeLambda('dynamicLabelHandler', lambdaPayload);
      }
      this.dynamicLabelManagerEditMode = false;
      this.toastrService.success('Dynamic label manager items updated successfully');
    } catch (error) {
      console.log('cannot update the dynamic label manager items error - ', error);
    }
  }

  async updateTagsAndCategoriesBatch(updatedTagsPromises: any, updatedCategoriesPromises: any): Promise<void> {
    try {
      const updatedTagsPromisesBatch = [];
      const updatedCategoriesPromisesBatch = [];
      for (let i = 0; i < updatedTagsPromises.length; i += 10) {
        updatedTagsPromisesBatch.push(updatedTagsPromises.slice(i, i + 10));
      }
      for (let i = 0; i < updatedCategoriesPromises.length; i += 10) {
        updatedCategoriesPromisesBatch.push(updatedCategoriesPromises.slice(i, i + 10));
      }
      await Promise.all(updatedTagsPromisesBatch.map(batch => Promise.all(batch)));
      await Promise.all(updatedCategoriesPromisesBatch.map(batch => Promise.all(batch)));
    } catch (error) {
      console.log('cannot update the tags and categories batch error - ', error);
      throw error;
    }
  }

  openBulkDynamicLabelUploadPopup(): void {
    const modalRef = this.modalService.open(
      BulkDynamicLabelUploadComponent,
      this.ngbModalOptionsDynamicLabelBulkUpload
    );
    modalRef.componentInstance.type = this.dynamicLabelManagerMapper.type;
    modalRef.componentInstance.entityId = this.entityId;
    modalRef.componentInstance.defaultCategories = this.dynamicLabelManagerMapper.categories;

    modalRef.componentInstance.closePopUp.subscribe((event: boolean) => {
      if (event) {
        modalRef.close();
      }
    });

    modalRef.componentInstance.data.subscribe(async (data: any) => {
      modalRef.close();
      this.toastrService.info('Uploading dynamic label manager items...');
      this.isDynamicLabelManagerLoading = true;
      if (data?.tags?.values.length) {
        data.tags.values = this.handleBulkUploadValidation(data.tags, true);
        if (data.tags?.values.length) {
          this.createBulkDynamicLabelTags(data.tags);
        }
      }

      if (data?.categories?.values.length) {
        // First check if it is already exist, don't create it again.
        data.categories.values = this.handleBulkUploadValidation(data.categories, false);
        if (data.categories?.values.length) {
          this.createBulkDynamicLabelCategories(data.categories);
        }
      }
      await Promise.all(this.bulkUploadPromise);
      this.isDynamicLabelManagerLoading = false;
      this.bulkUploadPromise = [];
      this.toastrService.success('Dynamic label manager items uploaded successfully');
    });
  }

  // Handling bulk upload validation.
  handleBulkUploadValidation(data: any, isTags: boolean): any {
    if (isTags) {
      return data.values.filter(tagObject => {
        return Object.values(tagObject).some(value => {
          return value !== null && value !== undefined && value !== '';
        });
      });
    } else {
      return data.values.filter(categoryObj => {
        if (this.dynamicLabelManagerMapper.type === LabelType.POLICY) {
          const policyCategoryValue = categoryObj[DynamicLabelManagerSections.POLICY_CATEGORIES];
          const policySubcategoryValue = categoryObj[DynamicLabelManagerSections.POLICY_SUB_CATEGORIES]; // Assuming this is the key name

          const hasPolicyCategory =
            policyCategoryValue !== null && policyCategoryValue !== undefined && policyCategoryValue !== '';
          const hasPolicySubcategory =
            policySubcategoryValue !== null && policySubcategoryValue !== undefined && policySubcategoryValue !== '';

          // Case 1: If policy categories is empty and policy subcategories is not empty -> reject (return false)
          if (!hasPolicyCategory && hasPolicySubcategory) {
            return false;
          }

          // Case 2: If policy categories has value and policy subcategories doesn't -> accept (return true)
          // Case 3: If both have values -> accept (return true)
          if (hasPolicyCategory) {
            return true;
          }

          // If both are empty -> reject
          return false;
        } else {
          // For non-POLICY type: Check if the object has any non-empty value
          return Object.values(categoryObj).some(value => value !== null && value !== undefined && value !== '');
        }
      });
    }
  }

  createBulkDynamicLabelTags(tags: any): void {
    tags.values.forEach(tagObject => {
      Object.values(tagObject).forEach((value: string) => {
        // already existing tag check.
        const alreadyExistingTag = this.dynamicLabelManagerMapper.tags.find(
          t => typeof value === 'string' && t.name === value
        );
        if (alreadyExistingTag) {
          return;
        }
        if (value !== null && value !== undefined && value !== '' && typeof value === 'string') {
          this.newTagValue = value.trim();
          this.addNewTagOrCategory(
            this.dynamicLabelManagerMapper.tagsTitle as DynamicLabelManagerSections,
            null,
            this.dynamicLabelManagerMapper.type,
            true
          );
        }
      });
    });
  }

  createBulkDynamicLabelCategories(categories: any): void {
    categories.values.forEach(categoryObj => {
      if (this.dynamicLabelManagerMapper.type === LabelType.POLICY) {
        // 1- Need to create a mapper with the same name Policy Category.
        const policyCategoryValue = categoryObj[DynamicLabelManagerSections.POLICY_CATEGORIES];
        const policySubcategoryValue = categoryObj[DynamicLabelManagerSections.POLICY_SUB_CATEGORIES];

        // 1- First need to check for the policy category is already exists or not.
        let alreadyExistingPolicyCategory = this.dynamicLabelManagerMapper.categories.find(
          c => c.name === policyCategoryValue
        );
        if (!alreadyExistingPolicyCategory) {
          this.newTagValue = policyCategoryValue;
          if (this.newTagValue !== null && this.newTagValue !== undefined && this.newTagValue !== '') {
            this.addNewTagOrCategory(
              this.dynamicLabelManagerMapper.categoriesTitle as DynamicLabelManagerSections,
              null,
              this.dynamicLabelManagerMapper.type,
              true
            );
            alreadyExistingPolicyCategory = this.dynamicLabelManagerMapper.categories.find(
              c => c.name === policyCategoryValue
            );
          }
        }

        // 2- Then need to check for the policy subcategories is already exists or not.
        let alreadyExistingPolicySubcategory = alreadyExistingPolicyCategory.values.find(
          v => v.name === policySubcategoryValue
        );
        if (!alreadyExistingPolicySubcategory) {
          this.newTagValue = policySubcategoryValue;
          if (this.newTagValue !== null && this.newTagValue !== undefined && this.newTagValue !== '') {
            this.addNewTagOrCategory(
              this.dynamicLabelManagerMapper.categoriesTitle as DynamicLabelManagerSections,
              alreadyExistingPolicyCategory.name,
              this.dynamicLabelManagerMapper.type,
              true
            );
            alreadyExistingPolicySubcategory = alreadyExistingPolicyCategory.values.find(
              v => v.name === policySubcategoryValue
            );
          }
        }
      } else {
        const categoryName =
          categoryObj[DynamicLabelManagerSections.GENERAL_CATEGORIES] ||
          categoryObj[DynamicLabelManagerSections.RISK_CATEGORIES];
        const alreadyExistingCategory = this.dynamicLabelManagerMapper.categories.find(c => c.name === categoryName);
        if (!alreadyExistingCategory) {
          this.newTagValue = categoryName;
          if (this.newTagValue !== null && this.newTagValue !== undefined && this.newTagValue !== '') {
            this.addNewTagOrCategory(
              this.dynamicLabelManagerMapper.categoriesTitle as DynamicLabelManagerSections,
              null,
              this.dynamicLabelManagerMapper.type,
              true
            );
          }
        }
      }
    });
  }
  // Add helper methods
  getCategoryColor(name: string): string {
    const group = this.defaultCategoryGroups.find(g => g.name === name);
    return group ? group.color : '';
  }

  isDefaultCategory(name: string): boolean {
    return this.defaultCategoryGroups.some(g => g.name === name);
  }

  // Optional: Helper to check if an item is a default item
  isDefaultCategoryItem(name: string): boolean {
    // Check if this name exists in any of the default groups' items
    // Note: items are Enums (strings), so strict comparison should work if names match
    return this.defaultCategoryGroups.some(g => g.items.includes(name as any));
  }
  //* Update Scoring Base
  async updateScoringBase(scoringBase: number): Promise<void> {
    try {
      if (!scoringBase) {
        scoringBase = DEFAULT_SCORE_BASE;
      }
      const scoringPayload = { id: this.entityId, scoringBase };
      await this.customAPI.UpdateEntity(scoringPayload);
      this.rootEntityContextService.addOrUpdateSubEntityInCache(scoringPayload);
      //* Update in cache in Score Service
      this.scoreBaseService.updateEntityScoreBaseInCache(this.entityId, scoringBase, true);
      this.toastrService.success('Scoring Base updated successfully');
    } catch (e) {
      console.error('Error in updating Score Base...', e);
    }
  }
}
